
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexS4oSzLddqG_45Y8rLQ1SARDA5rto8qKBGrDO2NWNiII5gMeta } from "/home/runner/work/app/app/pages/index.vue?macro=true";
import { default as loginmaT4clFRa0OvN5N9IytH5rLlybNYC4zinvUwy0BVmroMeta } from "/home/runner/work/app/app/pages/login.vue?macro=true";
import { default as cajaGb3BnxkjqmS9yapr3jy6X2ulG7ErAxE0tvvUBRQjCakMeta } from "/home/runner/work/app/app/pages/pos/caja.vue?macro=true";
import { default as dashboardQ_45jHI9fF5tTYTXtT_LugqEM5oOaoksTAT8eASCaPRlUMeta } from "/home/runner/work/app/app/pages/dashboard.vue?macro=true";
import { default as indexUvcN1_YDcKQ6l3PUUCQdU4v2TZafSEvyjbcisDt7dpAMeta } from "/home/runner/work/app/app/pages/ehr/index.vue?macro=true";
import { default as index_v5RFe4XPdSdhawpupQ71oZpN_45fS7J7VHGZmuklBM54Meta } from "/home/runner/work/app/app/pages/pos/index.vue?macro=true";
import { default as loginl0F5akerhmkYT4y5K0csiwxC3ADkgO9OjL959ZCDmO0Meta } from "/home/runner/work/app/app/pages/auth/login.vue?macro=true";
import { default as comisiones_45utbzCtPi9oWHuwsKn8F_nGayagS7EdJVWILrSJJBPAMeta } from "/home/runner/work/app/app/pages/comisiones.vue?macro=true";
import { default as _91token_93cLi02kO1qsORWHuzIbElV8PiZpWPCmKrN0k63QWCrhcMeta } from "/home/runner/work/app/app/pages/rx/[token].vue?macro=true";
import { default as indexDE_zIHEGTSZMdHIg9HG_CL0lHJkvhqrdI1hxYSowHDYMeta } from "/home/runner/work/app/app/pages/admin/index.vue?macro=true";
import { default as indexHzCg8D_45nrgLZDC0aKUFHuT2GIMUTY4vWRK_yGIoH0AQMeta } from "/home/runner/work/app/app/pages/ayuda/index.vue?macro=true";
import { default as _91token_93pE81cQ2IZJOGzMT6zEY5zS8Q86DGFtv35o8n894dqZMMeta } from "/home/runner/work/app/app/pages/lab/[token].vue?macro=true";
import { default as ajustesqgv_4IqIkKEfuJX9dJ5lnw4pm2dsED_xnx86cWzheosMeta } from "/home/runner/work/app/app/pages/pos/ajustes.vue?macro=true";
import { default as indexFGzKdxNK71dz7nijtap_45QuM1w6FwmJD1YScZnVw6WBsMeta } from "/home/runner/work/app/app/pages/agenda/index.vue?macro=true";
import { default as confirmGmPFgcrTTChqoAJVkFfaiRACHdCfMOLv9dJvvFG2dyYMeta } from "/home/runner/work/app/app/pages/auth/confirm.vue?macro=true";
import { default as _91id_93Id0t_45aZCR5EQi2tnEw_45uvxCIoU1olkPyalx8Dq72S5EMeta } from "/home/runner/work/app/app/pages/billing/[id].vue?macro=true";
import { default as index6sEkSdCdpCLzUw3j_aDBUa_45mTLiXFKmEEftv7Z9K_fAMeta } from "/home/runner/work/app/app/pages/gastos/index.vue?macro=true";
import { default as mis_45archivosOuk5kQ14HbChHsrTWqLotXFPL8bHEuOPY94dA2O56K8Meta } from "/home/runner/work/app/app/pages/mis-archivos.vue?macro=true";
import { default as _91token_93OMXtB9gNkQC8kNsYzClzjCqVltCx_45xJRgJdxe_QA1YgMeta } from "/home/runner/work/app/app/pages/pago/[token].vue?macro=true";
import { default as indexUpJs70cJ_kopFoNa9CLjYzlQV8hbtFKq0hSGQp3DJLcMeta } from "/home/runner/work/app/app/pages/triaje/index.vue?macro=true";
import { default as indexZwTNgpxf44Uqizu9ZEEFbnMZktpZvzXV2IjG3rDH4pIMeta } from "/home/runner/work/app/app/pages/billing/index.vue?macro=true";
import { default as planl_45Kl7s0TjUNMzAnEPvQLdkGQKtPxFFFxZuKlE6Vu4goMeta } from "/home/runner/work/app/app/pages/cobranza/plan.vue?macro=true";
import { default as _91token_93uwXNwDNKqucdVVBK0osQtcebDACZa_455eoncN6Cb8c2UMeta } from "/home/runner/work/app/app/pages/cobro/[token].vue?macro=true";
import { default as appbutton1aJBPuDMUQlz9mZq8owxriaoSfwoBHyR7fVJJNBJqZwMeta } from "/home/runner/work/app/app/pages/dev/appbutton.vue?macro=true";
import { default as _91token_93ICQULwO3mFVKJlENpXXvcnDCXkUWEAKHvKZanwO4zEoMeta } from "/home/runner/work/app/app/pages/preop/[token].vue?macro=true";
import { default as newxFCpzQkQ9zgzxIpqZOEZ4_45bv6f_45k11X1UpP5ekpz2dsMeta } from "/home/runner/work/app/app/pages/surgeries/new.vue?macro=true";
import { default as index0ZJVNPrhRX8CIX3mgZFH1eJKvJ_Kr5FSXuWGaQpYkgYMeta } from "/home/runner/work/app/app/pages/admin/ux/index.vue?macro=true";
import { default as indexQoldWlT8_45bYMGf874HIx0PXty4PVPZr_45FozuCQU5ZowMeta } from "/home/runner/work/app/app/pages/cobranza/index.vue?macro=true";
import { default as indexYrV6E_4520L0jBji2nC5W_45tE9gtu6CKMO78n7F2haDSDMMeta } from "/home/runner/work/app/app/pages/espacios/index.vue?macro=true";
import { default as indexm3W_45l8NYNTlmMub3w6w8oTnhVW3Q1CkK1wwXxlW8AbwMeta } from "/home/runner/work/app/app/pages/informes/index.vue?macro=true";
import { default as _91token_93Cxxj2rNhzQAlq4KK9bBnBEsDSsR5y3UuZUI_3X7H8kIMeta } from "/home/runner/work/app/app/pages/intake/[token].vue?macro=true";
import { default as index_45sKE8yfVOma3Mlieibwmhol2DwC_45HQSQSDOgIqQMNXQMeta } from "/home/runner/work/app/app/pages/messages/index.vue?macro=true";
import { default as indexgOsvrbTLVdwB3u_gJ7WxHr5vv5GRlhGK_q_45bfLLl2M4Meta } from "/home/runner/work/app/app/pages/patients/index.vue?macro=true";
import { default as index42nqpFu8Nm2A_HQK_45GojNlsBeupI2Y5_FdtQfaBOLt8Meta } from "/home/runner/work/app/app/pages/payments/index.vue?macro=true";
import { default as privacy_45policyQ_hj431LpqqDSEj7ub_45NM2tR_5B0VWWnToGVMthdC_oMeta } from "/home/runner/work/app/app/pages/privacy-policy.vue?macro=true";
import { default as indexc41ySTNmQV4jgsIWQXM65uoYCZz6NHNJoSZsn2diN9MMeta } from "/home/runner/work/app/app/pages/settings/index.vue?macro=true";
import { default as _91token_93AyhODXE_45hlHKlX6Ot_nBO8_lEyS53fjMpDoTYTXV12EMeta } from "/home/runner/work/app/app/pages/shared/[token].vue?macro=true";
import { default as _91id_93gx7a0ROCVl3t2DooPlbcWqzv2paGoZne96SGN76_wu0Meta } from "/home/runner/work/app/app/pages/surgeries/[id].vue?macro=true";
import { default as _91id_93ATG_450o_45_453LTaB8rJ6lTb4RXsqpTj_45TxzZcVnJ_kprxoMeta } from "/home/runner/work/app/app/pages/admin/labs/[id].vue?macro=true";
import { default as indexxp_q4S8DNaf3pYotiMk6zbijwcNrySWBNESImQNke2AMeta } from "/home/runner/work/app/app/pages/bulletins/index.vue?macro=true";
import { default as agenda5lcRrFMGOv_K8dj_45OmcE1yHDZ2GnJzj79r73op_7SVMMeta } from "/home/runner/work/app/app/pages/cobranza/agenda.vue?macro=true";
import { default as equipohzL0fb_45dbYBsIW1aBN1U6u30ktC1TLPNGr3_45hlz9pJcMeta } from "/home/runner/work/app/app/pages/cobranza/equipo.vue?macro=true";
import { default as index2BcbLqAHmXJe0dLfWzUfu535zrCJ6nW3T7cBN3SZ_45goMeta } from "/home/runner/work/app/app/pages/consultas/index.vue?macro=true";
import { default as _91token_9374UvWkLPrZ6XUViP_45_RyXEMri6VPQQNPYDeEwO_mBxcMeta } from "/home/runner/work/app/app/pages/factura/[token].vue?macro=true";
import { default as agenday8beEOx2SZ7oJu5XG4KVQXKWg2yqONxzhIJk4pFhW3gMeta } from "/home/runner/work/app/app/pages/informes/agenda.vue?macro=true";
import { default as indexg0KmgfAbxa6PP67gj4tLDSis9XhQWTCbgYjz83jo16gMeta } from "/home/runner/work/app/app/pages/inventory/index.vue?macro=true";
import { default as createRaZrPRwfvoTjHPFPXUlYFiidVvqPItBh2CW9v9CLM78Meta } from "/home/runner/work/app/app/pages/patients/create.vue?macro=true";
import { default as _91id_93i5MJODPPoYqRVxGGqGcS81nmNC2ilbFxMC0HAiRBhtsMeta } from "/home/runner/work/app/app/pages/procedures/[id].vue?macro=true";
import { default as _91token_93ZcmNnwMBNALntkIJPTNsgGE81bwDJRDlD1X0tI6kOjQMeta } from "/home/runner/work/app/app/pages/referir/[token].vue?macro=true";
import { default as fiscalTPi9sFarEPkgdW8b3fi1ZGi3AnAfNotMjHvGr18XUbMMeta } from "/home/runner/work/app/app/pages/settings/fiscal.vue?macro=true";
import { default as indexGh4cn7bQPHxXZP_fN2uz0ZNZgAmw7w6o8slnJS77FAEMeta } from "/home/runner/work/app/app/pages/surgeries/index.vue?macro=true";
import { default as duplicadosWrjqYNIZZKjRoUX5mRtnc46JRTWgumBxHd8kGt3D7IkMeta } from "/home/runner/work/app/app/pages/admin/duplicados.vue?macro=true";
import { default as indexzLpOx0sStos9HD3Yl_K303OwbJmVMnLyaefbun5RVEoMeta } from "/home/runner/work/app/app/pages/admin/labs/index.vue?macro=true";
import { default as createI2qTAR8bO_45y_Lhd6JhLyEUDrAZzfRHL9wgqZ_45gs4zOgMeta } from "/home/runner/work/app/app/pages/bulletins/create.vue?macro=true";
import { default as embedb56U6yh_JUOsMofAHUfJsq48sszuHdIVmxLU_45Ma4GEEMeta } from "/home/runner/work/app/app/pages/c/[clinic]/embed.vue?macro=true";
import { default as indexKKs6xuIRpw2_w9KeUunNmachK1KFloRDy_45H_45Yh3_45csIMeta } from "/home/runner/work/app/app/pages/c/[clinic]/index.vue?macro=true";
import { default as indexBZDyQ12nDPHJxIPFVbtjoN1OE5p7_45R2neWJ3uWWIb84Meta } from "/home/runner/work/app/app/pages/descuentos/index.vue?macro=true";
import { default as clinicoYFfg8qhHEJgsz132d9gsFiTL_454y69qeTnHPODXwUNU8Meta } from "/home/runner/work/app/app/pages/informes/clinico.vue?macro=true";
import { default as generalFuSozj4A0naVfN69g2PIaL3ITPm5F2COFkjYxfn4jHIMeta } from "/home/runner/work/app/app/pages/informes/general.vue?macro=true";
import { default as insumosmuVjkNVzWY5uB8Oj70TqbOb6KonMInQKJM_JBdz0IegMeta } from "/home/runner/work/app/app/pages/informes/insumos.vue?macro=true";
import { default as indexn0Fa1g6jnikFTQQw8qwihm5Q6uDj8reaZY8ZUG6wAZIMeta } from "/home/runner/work/app/app/pages/lab-orders/index.vue?macro=true";
import { default as indexibH8sDFgnEB6CmuGXmc4S_45Y3vbgKsckxFee8HxZ1cCkMeta } from "/home/runner/work/app/app/pages/onboarding/index.vue?macro=true";
import { default as indexk0_u1Y4oTT_NceMccXpfoOAorJztmkF9iZf3hpwMGQUMeta } from "/home/runner/work/app/app/pages/portal/lab/index.vue?macro=true";
import { default as devolucionesVUftnI53cpx9zWwJZGuOZR8B4U4qRJvA_G3LN9PsoOoMeta } from "/home/runner/work/app/app/pages/pos/devoluciones.vue?macro=true";
import { default as indexHFnwk9hFveNECGkn6ZgteM98J0AqHZszIAer6qojjH8Meta } from "/home/runner/work/app/app/pages/procedures/index.vue?macro=true";
import { default as profilexKM_45eOp_45DuQ_7SridULICpgi4qbOtL1Ym8vDvG6QK7EMeta } from "/home/runner/work/app/app/pages/settings/profile.vue?macro=true";
import { default as index6oEx75D5WS6UC995Vov0ui02pVSPmYt_YvxZFWPz2NUMeta } from "/home/runner/work/app/app/pages/sucursales/index.vue?macro=true";
import { default as indexqOEQB8ZzV8lkTkSt1yCTIepuZ2LAzYwkNx034ao4TH8Meta } from "/home/runner/work/app/app/pages/admin/audit/index.vue?macro=true";
import { default as newr0ztdqWoatLSb8I_Ahs6QaCrS_HBjAT5v_45PNqeGYIhoMeta } from "/home/runner/work/app/app/pages/admin/clinics/new.vue?macro=true";
import { default as ordersDga5irCB449NuUzNS85_45g6ztdq1CqFQwPNkxbhNE9tMMeta } from "/home/runner/work/app/app/pages/admin/labs/orders.vue?macro=true";
import { default as newbPSI25qNYGi79j6o3RegZ_uCXfcPkWp6RAMbtXyDJyoMeta } from "/home/runner/work/app/app/pages/admin/modules/new.vue?macro=true";
import { default as indexBUzHu2zLNl6_45iYp5Ui_w4fXeI6TCWRyLc2R5f_459mYw8Meta } from "/home/runner/work/app/app/pages/admin/users/index.vue?macro=true";
import { default as nueva_45citaxhq6A524ifPVnMeBOBVP9_45hmd6ZCah4nhQTZzDb9QC8Meta } from "/home/runner/work/app/app/pages/agenda/nueva-cita.vue?macro=true";
import { default as set_45passwordKpB0Qxw9VhwiwIEsdfRQXfd15Cje3AEPYmo3_45P4AW94Meta } from "/home/runner/work/app/app/pages/auth/set-password.vue?macro=true";
import { default as clinicasc_45W1e6rd4myDM3uv5WA0eWK48YuTSf2dqAG_EYNclA4Meta } from "/home/runner/work/app/app/pages/cobranza/clinicas.vue?macro=true";
import { default as facturasKVCYLJ0iwSPnxRo2POzJU0VrTrLxjtzbUJUjKorDTY8Meta } from "/home/runner/work/app/app/pages/cobranza/facturas.vue?macro=true";
import { default as informesRX8WHO6fbGxkhP6rhteNeWXjKi7_w7ggenRL99OtIjYMeta } from "/home/runner/work/app/app/pages/cobranza/informes.vue?macro=true";
import { default as indexVRHYl1bPFO04YndUZmsyCd2e7547NSTkf8YRw4APww0Meta } from "/home/runner/work/app/app/pages/expedientes/index.vue?macro=true";
import { default as cobranzaGT7Vkk0EWeRZVec_458hA_45_459zzM_4XG89tT0qk3RDUONwMeta } from "/home/runner/work/app/app/pages/informes/cobranza.vue?macro=true";
import { default as estudioscscwMc_45iM45bVMzy3TXIi_45rMuzSCljC3XchIyj_45eBywMeta } from "/home/runner/work/app/app/pages/informes/estudios.vue?macro=true";
import { default as farmaciarACEAMX8L0qDChcmYFsL_AcEkU6SWEmyfxZH6VFhppUMeta } from "/home/runner/work/app/app/pages/informes/farmacia.vue?macro=true";
import { default as gananciaNAATKXLCWYS25FUWedS75Stp7ZfOO4MyHR0WaQXpx7cMeta } from "/home/runner/work/app/app/pages/informes/ganancia.vue?macro=true";
import { default as index_45ymvVhZZCPBcM_UyL8w7swwUy0H0EXnAg4BAXnSjlF4Meta } from "/home/runner/work/app/app/pages/laboratorio/index.vue?macro=true";
import { default as agendacyUXB6RglMSZlbyNoS4C1gkAVviqTG5LrM4imCSEvCgMeta } from "/home/runner/work/app/app/pages/portal/lab/agenda.vue?macro=true";
import { default as cobrosiZr1AgAW7arb9nXhP_456ZslyPuZ9q8m0nkhyVigylCw8Meta } from "/home/runner/work/app/app/pages/portal/lab/cobros.vue?macro=true";
import { default as fiscal4AijQ5Hmadzl54FWSgc1YFnJPcX6tcvL2DaLW2xFTf4Meta } from "/home/runner/work/app/app/pages/portal/lab/fiscal.vue?macro=true";
import { default as indexqmHXmLlsbbCPsSM2piiaJ3UUR_N9eRONzh7fA642wA0Meta } from "/home/runner/work/app/app/pages/pregnancies/index.vue?macro=true";
import { default as newfx8z_45f_45itpCOQDiehbZAABimIwrtw15oxanN4SjIND4Meta } from "/home/runner/work/app/app/pages/recordatorios/new.vue?macro=true";
import { default as _91id_93brHs3ApX2wYl9ToBhIQ6CZOOYBP3LMYsWnIOsx8AfvsMeta } from "/home/runner/work/app/app/pages/reproduccion/[id].vue?macro=true";
import { default as brandingB04uBVT3TuAvP2h82kpB9waBDQwvWuIpNWQ7ah7GLS8Meta } from "/home/runner/work/app/app/pages/settings/branding.vue?macro=true";
import { default as whatsappsN56z6r_45CWSIMUmF4Jk1O5CyenPUcVhPn_45Sd8BhUne4Meta } from "/home/runner/work/app/app/pages/settings/whatsapp.vue?macro=true";
import { default as indexTrngx9eGKWI10bbLyG52eVAJkL9pLU_45XhcuJ7wPlkf4Meta } from "/home/runner/work/app/app/pages/solicitudes/index.vue?macro=true";
import { default as indexK_IfBoWPp3MFLLGobD4I_45bqsiuW3b1AjfF_jfS84IB8Meta } from "/home/runner/work/app/app/pages/admin/health/index.vue?macro=true";
import { default as _2faMCC04HKrW9gUM7kWvYaHxASGszSc6G_457wzvTSfOI_PcMeta } from "/home/runner/work/app/app/pages/admin/security/2fa.vue?macro=true";
import { default as indexBcVK4DWL069isO6NW8UW8N_5_450fzBiYL4s524NmH5k0Meta } from "/home/runner/work/app/app/pages/admin/system/index.vue?macro=true";
import { default as _91token_93aok6T10fomRVqN195XfvIPhpyzYqbBi7qWrUjn9_45OmgMeta } from "/home/runner/work/app/app/pages/evaluacion/[token].vue?macro=true";
import { default as pacientesN6ylmE1ug0ib8bajZpzNO36OnQ9eJDEa9Haj10xd5Y4Meta } from "/home/runner/work/app/app/pages/informes/pacientes.vue?macro=true";
import { default as _91token_93CDCxMaPxAgs5MlWR855QiS5WqUT6C_s239psxMGD_45h8Meta } from "/home/runner/work/app/app/pages/informes/r/[token].vue?macro=true";
import { default as retencion_45QGNsdKnQV7YagM1s8HSLEQCZUkUomqC5nJ9nvj79xcMeta } from "/home/runner/work/app/app/pages/informes/retencion.vue?macro=true";
import { default as cofeprisHS088Zm6ho22_Mp3_YDtQI6b1SatOaRDsKnXIKCQiacMeta } from "/home/runner/work/app/app/pages/inventory/cofepris.vue?macro=true";
import { default as edit8FQTdtrqygER0SZyv6Qtxw7Sy2oLk1qguMRa484PKBsMeta } from "/home/runner/work/app/app/pages/patients/[id]/edit.vue?macro=true";
import { default as ajustesFlYBCou2r5rzs_YcTMFgNqvZgYQ5wLcQ9kZDsytAUfIMeta } from "/home/runner/work/app/app/pages/portal/lab/ajustes.vue?macro=true";
import { default as referirOX98ZNSTH8dKXdw1LFUbYQr7J_1XBOj7MhlB_45D611e4Meta } from "/home/runner/work/app/app/pages/portal/lab/referir.vue?macro=true";
import { default as bancoCrGb6Y2k62jf5RZzjcvKfufFq0FtsHuGrJI73jmMqQIMeta } from "/home/runner/work/app/app/pages/reproduccion/banco.vue?macro=true";
import { default as indexeNcuBYio1rNWAA9M66o0WAAzMAtD9thBWY4Gxb4h71EMeta } from "/home/runner/work/app/app/pages/reproduccion/index.vue?macro=true";
import { default as estudiosFJMPwo8Fsx4u2WCD0yHsAEqp_45VTuASDrCgItbsxtHVYMeta } from "/home/runner/work/app/app/pages/admin/labs/estudios.vue?macro=true";
import { default as reportesv_458VrICp4D0cBsJx41MInMxAPMo0GnrU41lnXbPpSNgMeta } from "/home/runner/work/app/app/pages/admin/labs/reportes.vue?macro=true";
import { default as _91key_937YKRM1Ba_45ULzXLTwY0LIei6BWXUVNyI_45BIlwnUTTdn4Meta } from "/home/runner/work/app/app/pages/admin/modules/[key].vue?macro=true";
import { default as indexrvJAhtvEM4XcRLJ8q60o2F5j7te4lEfC_455RAtsXakqcMeta } from "/home/runner/work/app/app/pages/admin/modules/index.vue?macro=true";
import { default as indexJwajsd3sg46ByDEpELau_45OxCpzyffdVKDULonStDg_45oMeta } from "/home/runner/work/app/app/pages/admin/pricing/index.vue?macro=true";
import { default as reset_45passwordcXf5zMALp0yjtjBBOcds2RN2GAq5XdaPE1zEJWZnfD4Meta } from "/home/runner/work/app/app/pages/auth/reset-password.vue?macro=true";
import { default as _91token_93XY6nChZ4Aylw10h022hxuNpUBfpi_YIJFhPtsftZtpYMeta } from "/home/runner/work/app/app/pages/autofactura/[token].vue?macro=true";
import { default as edit_cdbSCsOY0JxmJkkJkbwmEDl1wlNxAzvrWs1ccTEmNYMeta } from "/home/runner/work/app/app/pages/bulletins/[id]/edit.vue?macro=true";
import { default as financieroQfFnLOzvkw_45giLBhApa_MMHt402e89Ef65wimutQRSoMeta } from "/home/runner/work/app/app/pages/informes/financiero.vue?macro=true";
import { default as inventariocRTuPFTitA7ZCtawTrdcBexOdUn6oZrTgfW8QKsAqqQMeta } from "/home/runner/work/app/app/pages/informes/inventario.vue?macro=true";
import { default as pendientesOzk8dYZEQkPksyIo3Yu87ylC0pPT5CyFkVHUyZ5216AMeta } from "/home/runner/work/app/app/pages/informes/pendientes.vue?macro=true";
import { default as produccionp1Tmv_45AmiN_45D2m7zw5MCCmymho31QuMMJECNkzQyfjwMeta } from "/home/runner/work/app/app/pages/informes/produccion.vue?macro=true";
import { default as ajustesdqugaJVVJjw7LXRsVZEoVLIVOoddTyhAdEt6buK2w4wMeta } from "/home/runner/work/app/app/pages/laboratorio/ajustes.vue?macro=true";
import { default as capturaJZsk3BMCIN5ijkMo0RV7NTuPBkyiTCg16xvQK29IvNUMeta } from "/home/runner/work/app/app/pages/laboratorio/captura.vue?macro=true";
import { default as _91token_93JW4Edt1lwalIQS6L5bcVSZ6BcjTEVL3PcsELjmkgFUEMeta } from "/home/runner/work/app/app/pages/mi-embarazo/[token].vue?macro=true";
import { default as indexvrjBOgBEjswq0Ps32eH5XmXtvVZ_45Zcz7eAtnsc08sN0Meta } from "/home/runner/work/app/app/pages/patients/[id]/index.vue?macro=true";
import { default as indexPTDxoQfRGMfDi_45twz4qa2uj9QIRrDG6V54Sm36eo8A4Meta } from "/home/runner/work/app/app/pages/payments/[id]/index.vue?macro=true";
import { default as bitacorax52q9zsqPueotXdhSg5r6_45nv_45kbKie5BovQDp0IzU2UMeta } from "/home/runner/work/app/app/pages/portal/lab/bitacora.vue?macro=true";
import { default as catalogotEGmPh4W_P2Im0_45tJDx0eTBnISi5c1NAugQsbv_1JcgMeta } from "/home/runner/work/app/app/pages/portal/lab/catalogo.vue?macro=true";
import { default as reportes2dT7ywojC4FdoxJ7w74I_OSguvNceI8QZOvAv6lw21oMeta } from "/home/runner/work/app/app/pages/portal/lab/reportes.vue?macro=true";
import { default as indexa34s3_45DyThTV0TYrdNwUE26PO1K0cGNUpsakL7ZNNjIMeta } from "/home/runner/work/app/app/pages/prescriptions/index.vue?macro=true";
import { default as indexheHjdT4VbaF846XWnLlwY6XpZorqT_jmcKflwcvETfUMeta } from "/home/runner/work/app/app/pages/recordatorios/index.vue?macro=true";
import { default as appearancehFMIdmJKkbgiH7DXTyaXPxznBsybFg_WE_45bpxGUqbx0Meta } from "/home/runner/work/app/app/pages/settings/appearance.vue?macro=true";
import { default as descuentoszzc3ZiGlejvefngyopvyfbXQNmofBsfcr6zTyJW59oIMeta } from "/home/runner/work/app/app/pages/settings/descuentos.vue?macro=true";
import { default as _91id_93WwpqK9N7W9hL3HNgf_45ZfwKj0MAtujirRgWcFO6V3XgIMeta } from "/home/runner/work/app/app/pages/settings/users/[id].vue?macro=true";
import { default as indexKny0WPBQM2DoiX9sVG_0y0Y4ooJav4wm_O8jnWuunu4Meta } from "/home/runner/work/app/app/pages/admin/agencias/index.vue?macro=true";
import { default as indexuBxO3qduWNVXKTUXkQVI_45Ik6HcpUHqwrJQMNsoS6nJUMeta } from "/home/runner/work/app/app/pages/admin/cofepris/index.vue?macro=true";
import { default as indextQ6ZeD3zfiBsC0J_459M_0pG_45fPUkXQhlLgeMz9_455CnVQMeta } from "/home/runner/work/app/app/pages/admin/security/index.vue?macro=true";
import { default as indexFvKC9whc8mIqK6o1TR_45j1zysdAnpkWR40olIbBO_459mIMeta } from "/home/runner/work/app/app/pages/admin/whatsapp/index.vue?macro=true";
import { default as configuracion9ga54hSNECVKNUPb5hOK1ADLuAdITDU8JTnywu4zjfgMeta } from "/home/runner/work/app/app/pages/agenda/configuracion.vue?macro=true";
import { default as forgot_45passwordPW5_45iO0Up8Fo63AtXO9rw8qNme_cWHac0Ld__8yf4M8Meta } from "/home/runner/work/app/app/pages/auth/forgot-password.vue?macro=true";
import { default as _91id_93ks44P3EX1iBGO_45MBwpee_45KmBng3KUX87FCWvI3Y_eeAMeta } from "/home/runner/work/app/app/pages/cuentas-medicos/[id].vue?macro=true";
import { default as operacionaltAaArBD6WoREMco2jsuD6ksfZC6o3fZ5clO9uuLzK5IMeta } from "/home/runner/work/app/app/pages/informes/operacional.vue?macro=true";
import { default as catalogoOZcMh6Jni77DRiK5hvnbvKAzypj8ZXlYq5ZfekbiZXUMeta } from "/home/runner/work/app/app/pages/laboratorio/catalogo.vue?macro=true";
import { default as ginecoJ5J8a5gVVhV2puKzcjQcxACPsankPfBFli2r9lanqUoMeta } from "/home/runner/work/app/app/pages/patients/[id]/gineco.vue?macro=true";
import { default as esperandoBaRhkIFMIclzGDUj9CHPyaNgAtY2V5LzPcf6ik_2VewMeta } from "/home/runner/work/app/app/pages/portal/lab/esperando.vue?macro=true";
import { default as lab_45preciosqbVXqMv9Dt3WBlFOVDilb5BiWOeYp81q6z8fAOzGKSEMeta } from "/home/runner/work/app/app/pages/settings/lab-precios.vue?macro=true";
import { default as indexgGCxdt38b35TPIyWVlnoA_jOHKxr6yAjhtEId85HB50Meta } from "/home/runner/work/app/app/pages/settings/users/index.vue?macro=true";
import { default as index_45at4P0njzN51hV007MIMoTqoB4kOZ8y_0ETa9dlA8t4Meta } from "/home/runner/work/app/app/pages/admin/analytics/index.vue?macro=true";
import { default as indexp_45ViG__457ADAo92zvsUNgP94tvLHTJ8FQUkVBINIoWh8Meta } from "/home/runner/work/app/app/pages/admin/reminders/index.vue?macro=true";
import { default as conciliacion5jxjTDDY6AxB7F5xaD5I82DGCIMO_Ce7_EYDP7JJnScMeta } from "/home/runner/work/app/app/pages/cobranza/conciliacion.vue?macro=true";
import { default as indexZ6i1xWyxbLVxgQUM3KYMMGYQmecidJa73gY6whGYzmUMeta } from "/home/runner/work/app/app/pages/cuentas-medicos/index.vue?macro=true";
import { default as indexWSxYz0vyUzBkl1CQhPziAJJDd_45PA0MXw80SCcWYnBxwMeta } from "/home/runner/work/app/app/pages/ehr/[patientId]/index.vue?macro=true";
import { default as summaryQYYs9RSp3hkD4XZZg1O_459lxDhVUz993aBwNO1wDRgsIMeta } from "/home/runner/work/app/app/pages/patients/[id]/summary.vue?macro=true";
import { default as vitalesW4JZ8MC_0FJtFhuFgPwUWVRUxapquMekdfgjSFHULKgMeta } from "/home/runner/work/app/app/pages/patients/[id]/vitales.vue?macro=true";
import { default as indexmdH_LVGTK89U7le_nfcSxjX8DbSuj1B5Bs_45rrjh7G34Meta } from "/home/runner/work/app/app/pages/patients/intake/index.vue?macro=true";
import { default as newtHm_452dMcebgi0QqlnIU5LLIJGbR0QLFgyuTYiYqql1EMeta } from "/home/runner/work/app/app/pages/payments/invoices/new.vue?macro=true";
import { default as resultadosjmf17Rf1zqGzJWfdkMfm_MGKNKphA5kc2nYbuRXzDKgMeta } from "/home/runner/work/app/app/pages/portal/lab/resultados.vue?macro=true";
import { default as sucursalesn61O_457sTyZKhi86PpZvoPsNe7QLdMNE8CS4Kw3Cqtx4Meta } from "/home/runner/work/app/app/pages/portal/lab/sucursales.vue?macro=true";
import { default as donantesi9izSh8hJ_fC3c7U_fki09XBMWIisSmrtrLmQKXNKe8Meta } from "/home/runner/work/app/app/pages/reproduccion/donantes.vue?macro=true";
import { default as inviteH4yX59PYs0fd_45aOPZMNAjKHoiUR8ABfywr35q240ieMMeta } from "/home/runner/work/app/app/pages/settings/users/invite.vue?macro=true";
import { default as vitals_45previewK03xDZ1aKeY4LBrC80IkWEtjWirWNoaJyhfQNrkt3XgMeta } from "/home/runner/work/app/app/pages/shared/vitals-preview.vue?macro=true";
import { default as _91id_9316g5UWfKm_457hIwZgbMUdfsHcNyo_Qod27CUTsX9LVJwMeta } from "/home/runner/work/app/app/pages/cuentas-pacientes/[id].vue?macro=true";
import { default as indexXOTojGEFcgg7eercU_5Wf4RTDwMZeQOAi2pLx0ED8IIMeta } from "/home/runner/work/app/app/pages/medicos-externos/index.vue?macro=true";
import { default as export_45helpersule_tJHbDqQTIGUzsG4LKya2DDJ89wIWGBLNbGArW8YMeta } from "/home/runner/work/app/app/pages/payments/export-helpers.ts?macro=true";
import { default as facturacionP6ycd2t0R5oMD3KVn1vef5w0waZnbxVAkhVcGw_45C7JAMeta } from "/home/runner/work/app/app/pages/portal/lab/facturacion.vue?macro=true";
import { default as indexdORGHLO1Kj1rJt5FD0Ia1v_3Hi9OFg_45_45hE2Ze8GQ_qQMeta } from "/home/runner/work/app/app/pages/registro/agencia/index.vue?macro=true";
import { default as indexjT7Q9v63BJUKcQcEu1YMHyKKrdKly_PWzp1J8b3e7V4Meta } from "/home/runner/work/app/app/pages/settings/catalog/index.vue?macro=true";
import { default as cfdi_45attemptsRbyqklnK_GT1Z15XMP_45htOOwliIpA4BOzD8ZGwjz1mMMeta } from "/home/runner/work/app/app/pages/settings/cfdi-attempts.vue?macro=true";
import { default as _91appointmentId_93PLVZNGeLFfiISz0GQoQS3PPHVEWlguIp1PUp6CW_5IkMeta } from "/home/runner/work/app/app/pages/triaje/[appointmentId].vue?macro=true";
import { default as editp28LWzbIb70ugT_45k9tODUkfJKaI6jTAgCkoKCaZ7z48Meta } from "/home/runner/work/app/app/pages/admin/clinics/[id]/edit.vue?macro=true";
import { default as indexOQsrWlznAgvE5Qy1g0wcXCqYOYQP8aq58K2WZrfhc78Meta } from "/home/runner/work/app/app/pages/admin/commissions/index.vue?macro=true";
import { default as sessionsZCWoLw3roY9FXitT0D5JFQQGkcc_TfgwNhvY8QXJxVcMeta } from "/home/runner/work/app/app/pages/admin/security/sessions.vue?macro=true";
import { default as indexV88ZA3Nce_45fnpuKEWNxRLOdqnmDDuuFQ7ugCMqHI_4590Meta } from "/home/runner/work/app/app/pages/cuentas-pacientes/index.vue?macro=true";
import { default as index9BVSGGx9gC17Pl9TJqxD80k2a5ojLs9rLFFdDnwbBZgMeta } from "/home/runner/work/app/app/pages/inventory/vacunas/index.vue?macro=true";
import { default as agenda_45publicacF9ti08dYr6BIlKwYrG1NT9O5AeD51f4zF67lRGD0KAMeta } from "/home/runner/work/app/app/pages/settings/agenda-publica.vue?macro=true";
import { default as indexj_CCBiy_45x2SPmsRIqgIc4BcFcx6asBD6taXCjhE9kdIMeta } from "/home/runner/work/app/app/pages/admin/clinics/[id]/index.vue?macro=true";
import { default as usersNz4H2plsbDoh5mtLAZVu7TKFGyhkLw9hTdGOzMVTKewMeta } from "/home/runner/work/app/app/pages/admin/clinics/[id]/users.vue?macro=true";
import { default as _91id_93Gr0tZGCcRqAqE2EEWX5E6D8k9uN_45EScD2Muie4876UoMeta } from "/home/runner/work/app/app/pages/admin/lab-templates/[id].vue?macro=true";
import { default as _91id_93e_k7XBEUJldSnhwvI2DyLsw3I0TuN5loHcG12XDLwX0Meta } from "/home/runner/work/app/app/pages/laboratorio/ordenes/[id].vue?macro=true";
import { default as estado_45cuentaF6Qbs23iCv_qdrCC0W_453JjdVqAIO3xr41OvqVnwHF_sMeta } from "/home/runner/work/app/app/pages/portal/lab/estado-cuenta.vue?macro=true";
import { default as google_45calendarMqh8eHgDDm70b0FKu5KfQQkpSgroC7vCbf95TX8BDa0Meta } from "/home/runner/work/app/app/pages/settings/google-calendar.vue?macro=true";
import { default as indexSoLXhZ6TJoy7TbEENORh2XwSvKNBEyIMz6TAUzz1AA8Meta } from "/home/runner/work/app/app/pages/settings/locations/index.vue?macro=true";
import { default as vademecum_45statscoAWnCmN19T2zae3HGYDrYx__NR2w_45XHoARWx4RPhSIMeta } from "/home/runner/work/app/app/pages/settings/vademecum-stats.vue?macro=true";
import { default as _91token_93Vdv9zZYRTYNp6_45BQl_45FaZ9z5Ob0CNFEPRM4PAfQ0YNoMeta } from "/home/runner/work/app/app/pages/surgeries/public/[token].vue?macro=true";
import { default as indexxEdFYTgZUWLIjGEt8Aw6Ebg132CpLEW_1cHUPVftzaAMeta } from "/home/runner/work/app/app/pages/vacunas/pendientes/index.vue?macro=true";
import { default as indexBSbS6FSW8DLzJuUxLWdYoJTxsGd6ozF6gtXnE3AdvnsMeta } from "/home/runner/work/app/app/pages/admin/lab-templates/index.vue?macro=true";
import { default as indexDKp4uED2kZz_45a_45voTwwmabfxkrCMJBTJSadB1zCUl9YMeta } from "/home/runner/work/app/app/pages/admin/notifications/index.vue?macro=true";
import { default as financiero_45ownerJiGtCtz_45IVRhIaXPdxBcoe81CsqKvKYghyKbCB9ua9UMeta } from "/home/runner/work/app/app/pages/informes/financiero-owner.vue?macro=true";
import { default as inventario_45ownertmX8A35hJNAqhrEiRuSSq5HIrtekMwI56TEdLkJSrEIMeta } from "/home/runner/work/app/app/pages/informes/inventario-owner.vue?macro=true";
import { default as indexPS11LrPanXjV7RGOXLrPPb9yYyVdqwarXwuzZ_jpjVkMeta } from "/home/runner/work/app/app/pages/inventory/movements/index.vue?macro=true";
import { default as createH0l9onx1gReQhQLa2FQnw__8ZBbIaOtqWIBct0ZnQmIMeta } from "/home/runner/work/app/app/pages/inventory/products/create.vue?macro=true";
import { default as indexF_n5aEgQnh01BMdn7m8L_45oEQTMT6juqRQ6WqGEfQEMYMeta } from "/home/runner/work/app/app/pages/inventory/suppliers/index.vue?macro=true";
import { default as _91token_93gsIj74MtEE4399S_5k13ck6_45K7jDaCg8JZaXXq_45pS0cMeta } from "/home/runner/work/app/app/pages/lab-orders/public/[token].vue?macro=true";
import { default as _91token_93Fw0HzNl46lR0PuNkrjbrMzoPQdUd_iUCedghpo3UPj0Meta } from "/home/runner/work/app/app/pages/lab-orders/upload/[token].vue?macro=true";
import { default as index_45L0Hr5baY569wtZp8w8RFYuy_Igk9h3AFdTsNnJMJzUMeta } from "/home/runner/work/app/app/pages/laboratorio/ordenes/index.vue?macro=true";
import { default as senalamientosiQLRk0vvC_plaigU6ov_6n7uqqQUkyvpcPEyjpl8yCIMeta } from "/home/runner/work/app/app/pages/laboratorio/senalamientos.vue?macro=true";
import { default as _91token_93_HF2uXNlII9WXww7YJJ8VZQC9IH6Ke5bAH_45J2XbdgQYMeta } from "/home/runner/work/app/app/pages/plan-alimentacion/[token].vue?macro=true";
import { default as reportes_45cobrow6FIcITyAMCeqicA4jrg6RYc0xHeq1xMtfu3oOWedVIMeta } from "/home/runner/work/app/app/pages/portal/lab/reportes-cobro.vue?macro=true";
import { default as vaccine_45scheduleFC76ETl9RQBvOAUBfqx9kJ4n0R6rrNV2ohYwQivt18oMeta } from "/home/runner/work/app/app/pages/settings/vaccine-schedule.vue?macro=true";
import { default as indexTHaV9QRFXDGwLvi5_4538fZYG7NR4sZiJzRdGQUcrBKM0Meta } from "/home/runner/work/app/app/pages/admin/especialidades/index.vue?macro=true";
import { default as indexTdukudrzdfyO8NHkW_LbXzTvSLrdJIk6EAOfVMPBtVEMeta } from "/home/runner/work/app/app/pages/inventory/categories/index.vue?macro=true";
import { default as indexNkinaBtIjZl19OLNuNO1H3XIHJVsS7HWQG_KwR_45I2icMeta } from "/home/runner/work/app/app/pages/patients/[id]/portal/index.vue?macro=true";
import { default as verificarPGY4MZtsMCkflkQWeIZQU5RVBwx_9trsektoWHOTvGwMeta } from "/home/runner/work/app/app/pages/registro/agencia/verificar.vue?macro=true";
import { default as agencias_45cobranza_45dWZUkuFcEWj4sZ1vuA24d_45mrNVvzpaIAjRORTaNCyEMeta } from "/home/runner/work/app/app/pages/settings/agencias-cobranza.vue?macro=true";
import { default as payment_45providers71iEO8Sdzkg8OCeUxS6O2lf5Fbh_7nRRef7KkfqemgAMeta } from "/home/runner/work/app/app/pages/settings/payment-providers.vue?macro=true";
import { default as indexR_898RY_Iwmu3ASVovQbnUgTN5qU1bXhn62Hx3BpvFEMeta } from "/home/runner/work/app/app/pages/settings/permissions/index.vue?macro=true";
import { default as staff_45assignmentsZQ5_poH7CGkc89wH1ngF3_45zknnvmuLjoCf7ENwNuzRwMeta } from "/home/runner/work/app/app/pages/settings/staff-assignments.vue?macro=true";
import { default as _91id_93Kxob_DXESDYQPTaz_453ay4EoC1tcYgfJ39kPXyImoL5kMeta } from "/home/runner/work/app/app/pages/admin/cofepris/clinics/[id].vue?macro=true";
import { default as _91slug_93QBM2hvz7wFwLne9OwsL_45pFsQrWSvb0z93CoO5PzHAi4Meta } from "/home/runner/work/app/app/pages/admin/especialidades/[slug].vue?macro=true";
import { default as ip_45allowlistJ8M5iXjn6Y_y0k7oO1iVJCtQFHEPIQ5l9Q9KjGEk0PIMeta } from "/home/runner/work/app/app/pages/admin/security/ip-allowlist.vue?macro=true";
import { default as calculadorasBkXUSYFYpA_1sg2_TWectIcfRgYyRMOV9L7tvQ0SmyIMeta } from "/home/runner/work/app/app/pages/maternal-fetal/calculadoras.vue?macro=true";
import { default as editkcEG1Dnrav86YcFffXOj4d5MOzlJz8KZKMRU8PwSJ7YMeta } from "/home/runner/work/app/app/pages/inventory/products/[id]/edit.vue?macro=true";
import { default as nuevaGoowFT2Racm9DGZNYX5CQjV2Y7nocR3WM2CX5nrL34sMeta } from "/home/runner/work/app/app/pages/patients/[id]/consulta/nueva.vue?macro=true";
import { default as indexIiCCXpRuqorAm59o52U9xZ07aOrxljcdXHuUlKPAlb0Meta } from "/home/runner/work/app/app/pages/patients/[id]/estudios/index.vue?macro=true";
import { default as insurance_45templatesL5VQAsH1pwi0oo7IdfJI32KA9ZCX5kSUic9BIbjYvowMeta } from "/home/runner/work/app/app/pages/settings/insurance-templates.vue?macro=true";
import { default as prescription_45fields9axyi0BJ1GcMTmBzD0MLbhAbcc1l3kal20naaskSSWkMeta } from "/home/runner/work/app/app/pages/settings/prescription-fields.vue?macro=true";
import { default as tarifas_45quirurgicasdQpGBhFI0zbXrve4aJO6Bi_qf8sWhwW5P_gP_EqeDSwMeta } from "/home/runner/work/app/app/pages/settings/tarifas-quirurgicas.vue?macro=true";
import { default as dashboard_45modular_45previewi6FZaWPHn9eJFAAbohgmJDBdax8cR_457MLzpEvtqhKn8Meta } from "/home/runner/work/app/app/pages/dev/dashboard-modular-preview.vue?macro=true";
import { default as indexGY9YwzwQfg_DH0ogQtmkrK6Xf1PesVyT1o7KT_kb8CAMeta } from "/home/runner/work/app/app/pages/inventory/products/[id]/index.vue?macro=true";
import { default as indexekxQnoziPT7b4Q2lhRGAbTdE7ovwDDLfW0lCjXSbwSUMeta } from "/home/runner/work/app/app/pages/patients/[id]/consultas/index.vue?macro=true";
import { default as _91id_93eT7zw6wc3st_A2UFczd9hN_45D7DStgFwITWfNBIHlBsUMeta } from "/home/runner/work/app/app/pages/prescriptions/plantillas/[id].vue?macro=true";
import { default as antecedentes_45templateofj_mEl3t1QjS9yfot_xFOblMiii7vYSEQSEnMV9HxMMeta } from "/home/runner/work/app/app/pages/settings/antecedentes-template.vue?macro=true";
import { default as index_45rZ5mp7qDqIVrS2K11JD_45Rs5HtX4VBRM74_oXgcEaDEMeta } from "/home/runner/work/app/app/pages/settings/payment-methods/index.vue?macro=true";
import { default as prescription_45templaterEO_1LhCpqJDRmvUozyc3vWs02TJYjuyupOvwfYf5HQMeta } from "/home/runner/work/app/app/pages/settings/prescription-template.vue?macro=true";
import { default as indexVb8fFR81oLRx8OLLGEgJ8ggjT11sWL4oJ9zZm4iJdzcMeta } from "/home/runner/work/app/app/pages/inventory/purchase-orders/index.vue?macro=true";
import { default as recordatorios_45cobranzaqLXyW8X9ArpyGpKLXd02UFv9fmFt6bxiK3k1Aw58JqcMeta } from "/home/runner/work/app/app/pages/settings/recordatorios-cobranza.vue?macro=true";
import { default as patients_45history_45previewwzIXb17oJwMgy3Y_45Kg6ArXVhjEESst_d6utY_453fhkx4Meta } from "/home/runner/work/app/app/pages/shared/patients-history-preview.vue?macro=true";
import { default as _91token_93_453qlnSWSvS7WISg_pXO_oXeu8ZPw9AYm3ymA7wVOt84Meta } from "/home/runner/work/app/app/pages/consentimiento-anestesia/[token].vue?macro=true";
import { default as _91id_93HLydJT7GLP_1D2Jh2wfFyIpVG4Ll4MfXkZvAWtfAM3IMeta } from "/home/runner/work/app/app/pages/settings/consultation-types/[id].vue?macro=true";
import { default as _91id_93mmTjxJuBBBC6_45GkDBF4QoVur_atE8XvgJQ5w8Y7YCd0Meta } from "/home/runner/work/app/app/pages/settings/whatsapp-plantilla/[id].vue?macro=true";
import { default as nacimientoeXCYZ2DZqq2UnJ0R1LHssLgzMjtukg3EhMY3hf3640EMeta } from "/home/runner/work/app/app/pages/patients/[id]/embarazo/nacimiento.vue?macro=true";
import { default as index6_l_r1JUtjgVZR9Wo_45_45pG8ssSecmdYg5AuwPpLpyP3sMeta } from "/home/runner/work/app/app/pages/settings/consultation-types/index.vue?macro=true";
import { default as indexoAvl9zbX5htB4K6yM4rzVNcoCHQYJdGVGMkGTBlaukoMeta } from "/home/runner/work/app/app/pages/inventory/purchase-orders/[id]/index.vue?macro=true";
import { default as _91studyId_93uCVyx0SmSOyZbvyzsjSXDNBg4aflz_45zXGis7s7vdqkMMeta } from "/home/runner/work/app/app/pages/patients/[id]/embarazo/usg/[studyId].vue?macro=true";
import { default as _91consultationId_93xtzuMs_5K6qyE1tFKcigLKSRzFQ3Y0e5C4nTMFVq_4584Meta } from "/home/runner/work/app/app/pages/patients/[id]/consulta/[consultationId].vue?macro=true";
import { default as _91visitId_93KZ0_zgAs975g0skfGETHQoGT9O1x7thb_C6XJCEzns4Meta } from "/home/runner/work/app/app/pages/patients/[id]/embarazo/prenatal/[visitId].vue?macro=true";
import { default as _91recordId_9358UZs4EhPEg_45RxQBvYGI9_ZdaMbspLdY2k0b_45Fin39MMeta } from "/home/runner/work/app/app/pages/patients/[id]/embarazo/anestesia/[recordId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/app/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginmaT4clFRa0OvN5N9IytH5rLlybNYC4zinvUwy0BVmroMeta || {},
    component: () => import("/home/runner/work/app/app/pages/login.vue")
  },
  {
    name: "pos-caja",
    path: "/pos/caja",
    meta: { ...(cajaGb3BnxkjqmS9yapr3jy6X2ulG7ErAxE0tvvUBRQjCakMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/pos/caja.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardQ_45jHI9fF5tTYTXtT_LugqEM5oOaoksTAT8eASCaPRlUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/dashboard.vue")
  },
  {
    name: "ehr",
    path: "/ehr",
    meta: { ...(indexUvcN1_YDcKQ6l3PUUCQdU4v2TZafSEvyjbcisDt7dpAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/ehr/index.vue")
  },
  {
    name: "pos",
    path: "/pos",
    meta: { ...(index_v5RFe4XPdSdhawpupQ71oZpN_45fS7J7VHGZmuklBM54Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/pos/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginl0F5akerhmkYT4y5K0csiwxC3ADkgO9OjL959ZCDmO0Meta || {},
    component: () => import("/home/runner/work/app/app/pages/auth/login.vue")
  },
  {
    name: "comisiones",
    path: "/comisiones",
    meta: { ...(comisiones_45utbzCtPi9oWHuwsKn8F_nGayagS7EdJVWILrSJJBPAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/comisiones.vue")
  },
  {
    name: "rx-token",
    path: "/rx/:token()",
    meta: _91token_93cLi02kO1qsORWHuzIbElV8PiZpWPCmKrN0k63QWCrhcMeta || {},
    component: () => import("/home/runner/work/app/app/pages/rx/[token].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexDE_zIHEGTSZMdHIg9HG_CL0lHJkvhqrdI1hxYSowHDYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/index.vue")
  },
  {
    name: "ayuda",
    path: "/ayuda",
    meta: { ...(indexHzCg8D_45nrgLZDC0aKUFHuT2GIMUTY4vWRK_yGIoH0AQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/ayuda/index.vue")
  },
  {
    name: "lab-token",
    path: "/lab/:token()",
    meta: _91token_93pE81cQ2IZJOGzMT6zEY5zS8Q86DGFtv35o8n894dqZMMeta || {},
    component: () => import("/home/runner/work/app/app/pages/lab/[token].vue")
  },
  {
    name: "pos-ajustes",
    path: "/pos/ajustes",
    meta: { ...(ajustesqgv_4IqIkKEfuJX9dJ5lnw4pm2dsED_xnx86cWzheosMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/pos/ajustes.vue")
  },
  {
    name: "agenda",
    path: "/agenda",
    meta: { ...(indexFGzKdxNK71dz7nijtap_45QuM1w6FwmJD1YScZnVw6WBsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/agenda/index.vue")
  },
  {
    name: "auth-confirm",
    path: "/auth/confirm",
    meta: confirmGmPFgcrTTChqoAJVkFfaiRACHdCfMOLv9dJvvFG2dyYMeta || {},
    component: () => import("/home/runner/work/app/app/pages/auth/confirm.vue")
  },
  {
    name: "billing-id",
    path: "/billing/:id()",
    meta: { ...(_91id_93Id0t_45aZCR5EQi2tnEw_45uvxCIoU1olkPyalx8Dq72S5EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/billing/[id].vue")
  },
  {
    name: "gastos",
    path: "/gastos",
    meta: { ...(index6sEkSdCdpCLzUw3j_aDBUa_45mTLiXFKmEEftv7Z9K_fAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/gastos/index.vue")
  },
  {
    name: "mis-archivos",
    path: "/mis-archivos",
    meta: { ...(mis_45archivosOuk5kQ14HbChHsrTWqLotXFPL8bHEuOPY94dA2O56K8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/mis-archivos.vue")
  },
  {
    name: "pago-token",
    path: "/pago/:token()",
    meta: _91token_93OMXtB9gNkQC8kNsYzClzjCqVltCx_45xJRgJdxe_QA1YgMeta || {},
    component: () => import("/home/runner/work/app/app/pages/pago/[token].vue")
  },
  {
    name: "triaje",
    path: "/triaje",
    meta: { ...(indexUpJs70cJ_kopFoNa9CLjYzlQV8hbtFKq0hSGQp3DJLcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/triaje/index.vue")
  },
  {
    name: "billing",
    path: "/billing",
    meta: { ...(indexZwTNgpxf44Uqizu9ZEEFbnMZktpZvzXV2IjG3rDH4pIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/billing/index.vue")
  },
  {
    name: "cobranza-plan",
    path: "/cobranza/plan",
    meta: { ...(planl_45Kl7s0TjUNMzAnEPvQLdkGQKtPxFFFxZuKlE6Vu4goMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/plan.vue")
  },
  {
    name: "cobro-token",
    path: "/cobro/:token()",
    meta: { ...(_91token_93uwXNwDNKqucdVVBK0osQtcebDACZa_455eoncN6Cb8c2UMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/app/app/pages/cobro/[token].vue")
  },
  {
    name: "dev-appbutton",
    path: "/dev/appbutton",
    meta: appbutton1aJBPuDMUQlz9mZq8owxriaoSfwoBHyR7fVJJNBJqZwMeta || {},
    component: () => import("/home/runner/work/app/app/pages/dev/appbutton.vue")
  },
  {
    name: "preop-token",
    path: "/preop/:token()",
    meta: _91token_93ICQULwO3mFVKJlENpXXvcnDCXkUWEAKHvKZanwO4zEoMeta || {},
    component: () => import("/home/runner/work/app/app/pages/preop/[token].vue")
  },
  {
    name: "surgeries-new",
    path: "/surgeries/new",
    meta: { ...(newxFCpzQkQ9zgzxIpqZOEZ4_45bv6f_45k11X1UpP5ekpz2dsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/surgeries/new.vue")
  },
  {
    name: "admin-ux",
    path: "/admin/ux",
    meta: { ...(index0ZJVNPrhRX8CIX3mgZFH1eJKvJ_Kr5FSXuWGaQpYkgYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/ux/index.vue")
  },
  {
    name: "cobranza",
    path: "/cobranza",
    meta: { ...(indexQoldWlT8_45bYMGf874HIx0PXty4PVPZr_45FozuCQU5ZowMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/index.vue")
  },
  {
    name: "espacios",
    path: "/espacios",
    meta: { ...(indexYrV6E_4520L0jBji2nC5W_45tE9gtu6CKMO78n7F2haDSDMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/espacios/index.vue")
  },
  {
    name: "informes",
    path: "/informes",
    meta: { ...(indexm3W_45l8NYNTlmMub3w6w8oTnhVW3Q1CkK1wwXxlW8AbwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/index.vue")
  },
  {
    name: "intake-token",
    path: "/intake/:token()",
    meta: _91token_93Cxxj2rNhzQAlq4KK9bBnBEsDSsR5y3UuZUI_3X7H8kIMeta || {},
    component: () => import("/home/runner/work/app/app/pages/intake/[token].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: { ...(index_45sKE8yfVOma3Mlieibwmhol2DwC_45HQSQSDOgIqQMNXQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/messages/index.vue")
  },
  {
    name: "patients",
    path: "/patients",
    meta: { ...(indexgOsvrbTLVdwB3u_gJ7WxHr5vv5GRlhGK_q_45bfLLl2M4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/index.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: { ...(index42nqpFu8Nm2A_HQK_45GojNlsBeupI2Y5_FdtQfaBOLt8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/payments/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyQ_hj431LpqqDSEj7ub_45NM2tR_5B0VWWnToGVMthdC_oMeta || {},
    component: () => import("/home/runner/work/app/app/pages/privacy-policy.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: { ...(indexc41ySTNmQV4jgsIWQXM65uoYCZz6NHNJoSZsn2diN9MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/index.vue")
  },
  {
    name: "shared-token",
    path: "/shared/:token()",
    meta: _91token_93AyhODXE_45hlHKlX6Ot_nBO8_lEyS53fjMpDoTYTXV12EMeta || {},
    component: () => import("/home/runner/work/app/app/pages/shared/[token].vue")
  },
  {
    name: "surgeries-id",
    path: "/surgeries/:id()",
    meta: { ...(_91id_93gx7a0ROCVl3t2DooPlbcWqzv2paGoZne96SGN76_wu0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/surgeries/[id].vue")
  },
  {
    name: "admin-labs-id",
    path: "/admin/labs/:id()",
    meta: { ...(_91id_93ATG_450o_45_453LTaB8rJ6lTb4RXsqpTj_45TxzZcVnJ_kprxoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/labs/[id].vue")
  },
  {
    name: "bulletins",
    path: "/bulletins",
    meta: { ...(indexxp_q4S8DNaf3pYotiMk6zbijwcNrySWBNESImQNke2AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/bulletins/index.vue")
  },
  {
    name: "cobranza-agenda",
    path: "/cobranza/agenda",
    meta: { ...(agenda5lcRrFMGOv_K8dj_45OmcE1yHDZ2GnJzj79r73op_7SVMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/agenda.vue")
  },
  {
    name: "cobranza-equipo",
    path: "/cobranza/equipo",
    meta: { ...(equipohzL0fb_45dbYBsIW1aBN1U6u30ktC1TLPNGr3_45hlz9pJcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/equipo.vue")
  },
  {
    name: "consultas",
    path: "/consultas",
    meta: { ...(index2BcbLqAHmXJe0dLfWzUfu535zrCJ6nW3T7cBN3SZ_45goMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/consultas/index.vue")
  },
  {
    name: "factura-token",
    path: "/factura/:token()",
    meta: _91token_9374UvWkLPrZ6XUViP_45_RyXEMri6VPQQNPYDeEwO_mBxcMeta || {},
    component: () => import("/home/runner/work/app/app/pages/factura/[token].vue")
  },
  {
    name: "informes-agenda",
    path: "/informes/agenda",
    meta: { ...(agenday8beEOx2SZ7oJu5XG4KVQXKWg2yqONxzhIJk4pFhW3gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/agenda.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: { ...(indexg0KmgfAbxa6PP67gj4tLDSis9XhQWTCbgYjz83jo16gMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/index.vue")
  },
  {
    name: "patients-create",
    path: "/patients/create",
    meta: { ...(createRaZrPRwfvoTjHPFPXUlYFiidVvqPItBh2CW9v9CLM78Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/create.vue")
  },
  {
    name: "procedures-id",
    path: "/procedures/:id()",
    meta: { ...(_91id_93i5MJODPPoYqRVxGGqGcS81nmNC2ilbFxMC0HAiRBhtsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/procedures/[id].vue")
  },
  {
    name: "referir-token",
    path: "/referir/:token()",
    meta: _91token_93ZcmNnwMBNALntkIJPTNsgGE81bwDJRDlD1X0tI6kOjQMeta || {},
    component: () => import("/home/runner/work/app/app/pages/referir/[token].vue")
  },
  {
    name: "settings-fiscal",
    path: "/settings/fiscal",
    meta: { ...(fiscalTPi9sFarEPkgdW8b3fi1ZGi3AnAfNotMjHvGr18XUbMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/fiscal.vue")
  },
  {
    name: "surgeries",
    path: "/surgeries",
    meta: { ...(indexGh4cn7bQPHxXZP_fN2uz0ZNZgAmw7w6o8slnJS77FAEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/surgeries/index.vue")
  },
  {
    name: "admin-duplicados",
    path: "/admin/duplicados",
    meta: { ...(duplicadosWrjqYNIZZKjRoUX5mRtnc46JRTWgumBxHd8kGt3D7IkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/duplicados.vue")
  },
  {
    name: "admin-labs",
    path: "/admin/labs",
    meta: { ...(indexzLpOx0sStos9HD3Yl_K303OwbJmVMnLyaefbun5RVEoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/labs/index.vue")
  },
  {
    name: "bulletins-create",
    path: "/bulletins/create",
    meta: { ...(createI2qTAR8bO_45y_Lhd6JhLyEUDrAZzfRHL9wgqZ_45gs4zOgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/bulletins/create.vue")
  },
  {
    name: "c-clinic-embed",
    path: "/c/:clinic()/embed",
    meta: embedb56U6yh_JUOsMofAHUfJsq48sszuHdIVmxLU_45Ma4GEEMeta || {},
    component: () => import("/home/runner/work/app/app/pages/c/[clinic]/embed.vue")
  },
  {
    name: "c-clinic",
    path: "/c/:clinic()",
    meta: indexKKs6xuIRpw2_w9KeUunNmachK1KFloRDy_45H_45Yh3_45csIMeta || {},
    component: () => import("/home/runner/work/app/app/pages/c/[clinic]/index.vue")
  },
  {
    name: "descuentos",
    path: "/descuentos",
    meta: { ...(indexBZDyQ12nDPHJxIPFVbtjoN1OE5p7_45R2neWJ3uWWIb84Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/descuentos/index.vue")
  },
  {
    name: "informes-clinico",
    path: "/informes/clinico",
    meta: { ...(clinicoYFfg8qhHEJgsz132d9gsFiTL_454y69qeTnHPODXwUNU8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/clinico.vue")
  },
  {
    name: "informes-general",
    path: "/informes/general",
    meta: { ...(generalFuSozj4A0naVfN69g2PIaL3ITPm5F2COFkjYxfn4jHIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/general.vue")
  },
  {
    name: "informes-insumos",
    path: "/informes/insumos",
    meta: { ...(insumosmuVjkNVzWY5uB8Oj70TqbOb6KonMInQKJM_JBdz0IegMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/insumos.vue")
  },
  {
    name: "lab-orders",
    path: "/lab-orders",
    meta: { ...(indexn0Fa1g6jnikFTQQw8qwihm5Q6uDj8reaZY8ZUG6wAZIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/lab-orders/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(indexibH8sDFgnEB6CmuGXmc4S_45Y3vbgKsckxFee8HxZ1cCkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/onboarding/index.vue")
  },
  {
    name: "portal-lab",
    path: "/portal/lab",
    meta: { ...(indexk0_u1Y4oTT_NceMccXpfoOAorJztmkF9iZf3hpwMGQUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/index.vue")
  },
  {
    name: "pos-devoluciones",
    path: "/pos/devoluciones",
    meta: { ...(devolucionesVUftnI53cpx9zWwJZGuOZR8B4U4qRJvA_G3LN9PsoOoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/pos/devoluciones.vue")
  },
  {
    name: "procedures",
    path: "/procedures",
    meta: { ...(indexHFnwk9hFveNECGkn6ZgteM98J0AqHZszIAer6qojjH8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/procedures/index.vue")
  },
  {
    name: "settings-profile",
    path: "/settings/profile",
    meta: { ...(profilexKM_45eOp_45DuQ_7SridULICpgi4qbOtL1Ym8vDvG6QK7EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/profile.vue")
  },
  {
    name: "sucursales",
    path: "/sucursales",
    meta: { ...(index6oEx75D5WS6UC995Vov0ui02pVSPmYt_YvxZFWPz2NUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/sucursales/index.vue")
  },
  {
    name: "admin-audit",
    path: "/admin/audit",
    meta: { ...(indexqOEQB8ZzV8lkTkSt1yCTIepuZ2LAzYwkNx034ao4TH8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/audit/index.vue")
  },
  {
    name: "admin-clinics-new",
    path: "/admin/clinics/new",
    meta: { ...(newr0ztdqWoatLSb8I_Ahs6QaCrS_HBjAT5v_45PNqeGYIhoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/clinics/new.vue")
  },
  {
    name: "admin-labs-orders",
    path: "/admin/labs/orders",
    meta: { ...(ordersDga5irCB449NuUzNS85_45g6ztdq1CqFQwPNkxbhNE9tMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/labs/orders.vue")
  },
  {
    name: "admin-modules-new",
    path: "/admin/modules/new",
    meta: { ...(newbPSI25qNYGi79j6o3RegZ_uCXfcPkWp6RAMbtXyDJyoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/modules/new.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(indexBUzHu2zLNl6_45iYp5Ui_w4fXeI6TCWRyLc2R5f_459mYw8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/users/index.vue")
  },
  {
    name: "agenda-nueva-cita",
    path: "/agenda/nueva-cita",
    meta: { ...(nueva_45citaxhq6A524ifPVnMeBOBVP9_45hmd6ZCah4nhQTZzDb9QC8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/agenda/nueva-cita.vue")
  },
  {
    name: "auth-set-password",
    path: "/auth/set-password",
    meta: set_45passwordKpB0Qxw9VhwiwIEsdfRQXfd15Cje3AEPYmo3_45P4AW94Meta || {},
    component: () => import("/home/runner/work/app/app/pages/auth/set-password.vue")
  },
  {
    name: "cobranza-clinicas",
    path: "/cobranza/clinicas",
    meta: { ...(clinicasc_45W1e6rd4myDM3uv5WA0eWK48YuTSf2dqAG_EYNclA4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/clinicas.vue")
  },
  {
    name: "cobranza-facturas",
    path: "/cobranza/facturas",
    meta: { ...(facturasKVCYLJ0iwSPnxRo2POzJU0VrTrLxjtzbUJUjKorDTY8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/facturas.vue")
  },
  {
    name: "cobranza-informes",
    path: "/cobranza/informes",
    meta: { ...(informesRX8WHO6fbGxkhP6rhteNeWXjKi7_w7ggenRL99OtIjYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/informes.vue")
  },
  {
    name: "expedientes",
    path: "/expedientes",
    meta: { ...(indexVRHYl1bPFO04YndUZmsyCd2e7547NSTkf8YRw4APww0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/expedientes/index.vue")
  },
  {
    name: "informes-cobranza",
    path: "/informes/cobranza",
    meta: { ...(cobranzaGT7Vkk0EWeRZVec_458hA_45_459zzM_4XG89tT0qk3RDUONwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/cobranza.vue")
  },
  {
    name: "informes-estudios",
    path: "/informes/estudios",
    meta: { ...(estudioscscwMc_45iM45bVMzy3TXIi_45rMuzSCljC3XchIyj_45eBywMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/estudios.vue")
  },
  {
    name: "informes-farmacia",
    path: "/informes/farmacia",
    meta: { ...(farmaciarACEAMX8L0qDChcmYFsL_AcEkU6SWEmyfxZH6VFhppUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/farmacia.vue")
  },
  {
    name: "informes-ganancia",
    path: "/informes/ganancia",
    meta: { ...(gananciaNAATKXLCWYS25FUWedS75Stp7ZfOO4MyHR0WaQXpx7cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/ganancia.vue")
  },
  {
    name: "laboratorio",
    path: "/laboratorio",
    meta: index_45ymvVhZZCPBcM_UyL8w7swwUy0H0EXnAg4BAXnSjlF4Meta || {},
    component: () => import("/home/runner/work/app/app/pages/laboratorio/index.vue")
  },
  {
    name: "portal-lab-agenda",
    path: "/portal/lab/agenda",
    meta: { ...(agendacyUXB6RglMSZlbyNoS4C1gkAVviqTG5LrM4imCSEvCgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/agenda.vue")
  },
  {
    name: "portal-lab-cobros",
    path: "/portal/lab/cobros",
    meta: { ...(cobrosiZr1AgAW7arb9nXhP_456ZslyPuZ9q8m0nkhyVigylCw8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/cobros.vue")
  },
  {
    name: "portal-lab-fiscal",
    path: "/portal/lab/fiscal",
    meta: { ...(fiscal4AijQ5Hmadzl54FWSgc1YFnJPcX6tcvL2DaLW2xFTf4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/fiscal.vue")
  },
  {
    name: "pregnancies",
    path: "/pregnancies",
    meta: { ...(indexqmHXmLlsbbCPsSM2piiaJ3UUR_N9eRONzh7fA642wA0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/pregnancies/index.vue")
  },
  {
    name: "recordatorios-new",
    path: "/recordatorios/new",
    meta: { ...(newfx8z_45f_45itpCOQDiehbZAABimIwrtw15oxanN4SjIND4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/recordatorios/new.vue")
  },
  {
    name: "reproduccion-id",
    path: "/reproduccion/:id()",
    meta: { ...(_91id_93brHs3ApX2wYl9ToBhIQ6CZOOYBP3LMYsWnIOsx8AfvsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/reproduccion/[id].vue")
  },
  {
    name: "settings-branding",
    path: "/settings/branding",
    meta: { ...(brandingB04uBVT3TuAvP2h82kpB9waBDQwvWuIpNWQ7ah7GLS8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/branding.vue")
  },
  {
    name: "settings-whatsapp",
    path: "/settings/whatsapp",
    meta: { ...(whatsappsN56z6r_45CWSIMUmF4Jk1O5CyenPUcVhPn_45Sd8BhUne4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/whatsapp.vue")
  },
  {
    name: "solicitudes",
    path: "/solicitudes",
    meta: { ...(indexTrngx9eGKWI10bbLyG52eVAJkL9pLU_45XhcuJ7wPlkf4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/solicitudes/index.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(indexK_IfBoWPp3MFLLGobD4I_45bqsiuW3b1AjfF_jfS84IB8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/health/index.vue")
  },
  {
    name: "admin-security-2fa",
    path: "/admin/security/2fa",
    meta: { ...(_2faMCC04HKrW9gUM7kWvYaHxASGszSc6G_457wzvTSfOI_PcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/security/2fa.vue")
  },
  {
    name: "admin-system",
    path: "/admin/system",
    meta: { ...(indexBcVK4DWL069isO6NW8UW8N_5_450fzBiYL4s524NmH5k0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/system/index.vue")
  },
  {
    name: "evaluacion-token",
    path: "/evaluacion/:token()",
    meta: _91token_93aok6T10fomRVqN195XfvIPhpyzYqbBi7qWrUjn9_45OmgMeta || {},
    component: () => import("/home/runner/work/app/app/pages/evaluacion/[token].vue")
  },
  {
    name: "informes-pacientes",
    path: "/informes/pacientes",
    meta: { ...(pacientesN6ylmE1ug0ib8bajZpzNO36OnQ9eJDEa9Haj10xd5Y4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/pacientes.vue")
  },
  {
    name: "informes-r-token",
    path: "/informes/r/:token()",
    meta: _91token_93CDCxMaPxAgs5MlWR855QiS5WqUT6C_s239psxMGD_45h8Meta || {},
    component: () => import("/home/runner/work/app/app/pages/informes/r/[token].vue")
  },
  {
    name: "informes-retencion",
    path: "/informes/retencion",
    meta: { ...(retencion_45QGNsdKnQV7YagM1s8HSLEQCZUkUomqC5nJ9nvj79xcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/retencion.vue")
  },
  {
    name: "inventory-cofepris",
    path: "/inventory/cofepris",
    meta: { ...(cofeprisHS088Zm6ho22_Mp3_YDtQI6b1SatOaRDsKnXIKCQiacMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/cofepris.vue")
  },
  {
    name: "patients-id-edit",
    path: "/patients/:id()/edit",
    meta: { ...(edit8FQTdtrqygER0SZyv6Qtxw7Sy2oLk1qguMRa484PKBsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/edit.vue")
  },
  {
    name: "portal-lab-ajustes",
    path: "/portal/lab/ajustes",
    meta: { ...(ajustesFlYBCou2r5rzs_YcTMFgNqvZgYQ5wLcQ9kZDsytAUfIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/ajustes.vue")
  },
  {
    name: "portal-lab-referir",
    path: "/portal/lab/referir",
    meta: { ...(referirOX98ZNSTH8dKXdw1LFUbYQr7J_1XBOj7MhlB_45D611e4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/referir.vue")
  },
  {
    name: "reproduccion-banco",
    path: "/reproduccion/banco",
    meta: { ...(bancoCrGb6Y2k62jf5RZzjcvKfufFq0FtsHuGrJI73jmMqQIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/reproduccion/banco.vue")
  },
  {
    name: "reproduccion",
    path: "/reproduccion",
    meta: { ...(indexeNcuBYio1rNWAA9M66o0WAAzMAtD9thBWY4Gxb4h71EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/reproduccion/index.vue")
  },
  {
    name: "admin-labs-estudios",
    path: "/admin/labs/estudios",
    meta: { ...(estudiosFJMPwo8Fsx4u2WCD0yHsAEqp_45VTuASDrCgItbsxtHVYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/labs/estudios.vue")
  },
  {
    name: "admin-labs-reportes",
    path: "/admin/labs/reportes",
    meta: { ...(reportesv_458VrICp4D0cBsJx41MInMxAPMo0GnrU41lnXbPpSNgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/labs/reportes.vue")
  },
  {
    name: "admin-modules-key",
    path: "/admin/modules/:key()",
    meta: { ...(_91key_937YKRM1Ba_45ULzXLTwY0LIei6BWXUVNyI_45BIlwnUTTdn4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/modules/[key].vue")
  },
  {
    name: "admin-modules",
    path: "/admin/modules",
    meta: { ...(indexrvJAhtvEM4XcRLJ8q60o2F5j7te4lEfC_455RAtsXakqcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/modules/index.vue")
  },
  {
    name: "admin-pricing",
    path: "/admin/pricing",
    meta: { ...(indexJwajsd3sg46ByDEpELau_45OxCpzyffdVKDULonStDg_45oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/pricing/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45passwordcXf5zMALp0yjtjBBOcds2RN2GAq5XdaPE1zEJWZnfD4Meta || {},
    component: () => import("/home/runner/work/app/app/pages/auth/reset-password.vue")
  },
  {
    name: "autofactura-token",
    path: "/autofactura/:token()",
    meta: _91token_93XY6nChZ4Aylw10h022hxuNpUBfpi_YIJFhPtsftZtpYMeta || {},
    component: () => import("/home/runner/work/app/app/pages/autofactura/[token].vue")
  },
  {
    name: "bulletins-id-edit",
    path: "/bulletins/:id()/edit",
    meta: { ...(edit_cdbSCsOY0JxmJkkJkbwmEDl1wlNxAzvrWs1ccTEmNYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/bulletins/[id]/edit.vue")
  },
  {
    name: "informes-financiero",
    path: "/informes/financiero",
    meta: { ...(financieroQfFnLOzvkw_45giLBhApa_MMHt402e89Ef65wimutQRSoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/financiero.vue")
  },
  {
    name: "informes-inventario",
    path: "/informes/inventario",
    meta: { ...(inventariocRTuPFTitA7ZCtawTrdcBexOdUn6oZrTgfW8QKsAqqQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/inventario.vue")
  },
  {
    name: "informes-pendientes",
    path: "/informes/pendientes",
    meta: { ...(pendientesOzk8dYZEQkPksyIo3Yu87ylC0pPT5CyFkVHUyZ5216AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/pendientes.vue")
  },
  {
    name: "informes-produccion",
    path: "/informes/produccion",
    meta: { ...(produccionp1Tmv_45AmiN_45D2m7zw5MCCmymho31QuMMJECNkzQyfjwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/produccion.vue")
  },
  {
    name: "laboratorio-ajustes",
    path: "/laboratorio/ajustes",
    meta: { ...(ajustesdqugaJVVJjw7LXRsVZEoVLIVOoddTyhAdEt6buK2w4wMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/ajustes.vue")
  },
  {
    name: "laboratorio-captura",
    path: "/laboratorio/captura",
    meta: { ...(capturaJZsk3BMCIN5ijkMo0RV7NTuPBkyiTCg16xvQK29IvNUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/captura.vue")
  },
  {
    name: "mi-embarazo-token",
    path: "/mi-embarazo/:token()",
    meta: _91token_93JW4Edt1lwalIQS6L5bcVSZ6BcjTEVL3PcsELjmkgFUEMeta || {},
    component: () => import("/home/runner/work/app/app/pages/mi-embarazo/[token].vue")
  },
  {
    name: "patients-id",
    path: "/patients/:id()",
    meta: { ...(indexvrjBOgBEjswq0Ps32eH5XmXtvVZ_45Zcz7eAtnsc08sN0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/index.vue")
  },
  {
    name: "payments-id",
    path: "/payments/:id()",
    meta: { ...(indexPTDxoQfRGMfDi_45twz4qa2uj9QIRrDG6V54Sm36eo8A4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/payments/[id]/index.vue")
  },
  {
    name: "portal-lab-bitacora",
    path: "/portal/lab/bitacora",
    meta: { ...(bitacorax52q9zsqPueotXdhSg5r6_45nv_45kbKie5BovQDp0IzU2UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/bitacora.vue")
  },
  {
    name: "portal-lab-catalogo",
    path: "/portal/lab/catalogo",
    meta: { ...(catalogotEGmPh4W_P2Im0_45tJDx0eTBnISi5c1NAugQsbv_1JcgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/catalogo.vue")
  },
  {
    name: "portal-lab-reportes",
    path: "/portal/lab/reportes",
    meta: { ...(reportes2dT7ywojC4FdoxJ7w74I_OSguvNceI8QZOvAv6lw21oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/reportes.vue")
  },
  {
    name: "prescriptions",
    path: "/prescriptions",
    meta: { ...(indexa34s3_45DyThTV0TYrdNwUE26PO1K0cGNUpsakL7ZNNjIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/prescriptions/index.vue")
  },
  {
    name: "recordatorios",
    path: "/recordatorios",
    meta: { ...(indexheHjdT4VbaF846XWnLlwY6XpZorqT_jmcKflwcvETfUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/recordatorios/index.vue")
  },
  {
    name: "settings-appearance",
    path: "/settings/appearance",
    meta: { ...(appearancehFMIdmJKkbgiH7DXTyaXPxznBsybFg_WE_45bpxGUqbx0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/appearance.vue")
  },
  {
    name: "settings-descuentos",
    path: "/settings/descuentos",
    meta: { ...(descuentoszzc3ZiGlejvefngyopvyfbXQNmofBsfcr6zTyJW59oIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/descuentos.vue")
  },
  {
    name: "settings-users-id",
    path: "/settings/users/:id()",
    meta: { ...(_91id_93WwpqK9N7W9hL3HNgf_45ZfwKj0MAtujirRgWcFO6V3XgIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/users/[id].vue")
  },
  {
    name: "admin-agencias",
    path: "/admin/agencias",
    meta: { ...(indexKny0WPBQM2DoiX9sVG_0y0Y4ooJav4wm_O8jnWuunu4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/agencias/index.vue")
  },
  {
    name: "admin-cofepris",
    path: "/admin/cofepris",
    meta: { ...(indexuBxO3qduWNVXKTUXkQVI_45Ik6HcpUHqwrJQMNsoS6nJUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/cofepris/index.vue")
  },
  {
    name: "admin-security",
    path: "/admin/security",
    meta: { ...(indextQ6ZeD3zfiBsC0J_459M_0pG_45fPUkXQhlLgeMz9_455CnVQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/security/index.vue")
  },
  {
    name: "admin-whatsapp",
    path: "/admin/whatsapp",
    meta: { ...(indexFvKC9whc8mIqK6o1TR_45j1zysdAnpkWR40olIbBO_459mIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/whatsapp/index.vue")
  },
  {
    name: "agenda-configuracion",
    path: "/agenda/configuracion",
    meta: { ...(configuracion9ga54hSNECVKNUPb5hOK1ADLuAdITDU8JTnywu4zjfgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/agenda/configuracion.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordPW5_45iO0Up8Fo63AtXO9rw8qNme_cWHac0Ld__8yf4M8Meta || {},
    component: () => import("/home/runner/work/app/app/pages/auth/forgot-password.vue")
  },
  {
    name: "cuentas-medicos-id",
    path: "/cuentas-medicos/:id()",
    meta: { ...(_91id_93ks44P3EX1iBGO_45MBwpee_45KmBng3KUX87FCWvI3Y_eeAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cuentas-medicos/[id].vue")
  },
  {
    name: "informes-operacional",
    path: "/informes/operacional",
    meta: { ...(operacionaltAaArBD6WoREMco2jsuD6ksfZC6o3fZ5clO9uuLzK5IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/operacional.vue")
  },
  {
    name: "laboratorio-catalogo",
    path: "/laboratorio/catalogo",
    meta: { ...(catalogoOZcMh6Jni77DRiK5hvnbvKAzypj8ZXlYq5ZfekbiZXUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/catalogo.vue")
  },
  {
    name: "patients-id-gineco",
    path: "/patients/:id()/gineco",
    meta: { ...(ginecoJ5J8a5gVVhV2puKzcjQcxACPsankPfBFli2r9lanqUoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/gineco.vue")
  },
  {
    name: "portal-lab-esperando",
    path: "/portal/lab/esperando",
    meta: { ...(esperandoBaRhkIFMIclzGDUj9CHPyaNgAtY2V5LzPcf6ik_2VewMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/esperando.vue")
  },
  {
    name: "settings-lab-precios",
    path: "/settings/lab-precios",
    meta: { ...(lab_45preciosqbVXqMv9Dt3WBlFOVDilb5BiWOeYp81q6z8fAOzGKSEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/lab-precios.vue")
  },
  {
    name: "settings-users",
    path: "/settings/users",
    meta: { ...(indexgGCxdt38b35TPIyWVlnoA_jOHKxr6yAjhtEId85HB50Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/users/index.vue")
  },
  {
    name: "admin-analytics",
    path: "/admin/analytics",
    meta: { ...(index_45at4P0njzN51hV007MIMoTqoB4kOZ8y_0ETa9dlA8t4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/analytics/index.vue")
  },
  {
    name: "admin-reminders",
    path: "/admin/reminders",
    meta: { ...(indexp_45ViG__457ADAo92zvsUNgP94tvLHTJ8FQUkVBINIoWh8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/reminders/index.vue")
  },
  {
    name: "cobranza-conciliacion",
    path: "/cobranza/conciliacion",
    meta: { ...(conciliacion5jxjTDDY6AxB7F5xaD5I82DGCIMO_Ce7_EYDP7JJnScMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cobranza/conciliacion.vue")
  },
  {
    name: "cuentas-medicos",
    path: "/cuentas-medicos",
    meta: { ...(indexZ6i1xWyxbLVxgQUM3KYMMGYQmecidJa73gY6whGYzmUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cuentas-medicos/index.vue")
  },
  {
    name: "ehr-patientId",
    path: "/ehr/:patientId()",
    component: () => import("/home/runner/work/app/app/pages/ehr/[patientId]/index.vue")
  },
  {
    name: "patients-id-summary",
    path: "/patients/:id()/summary",
    meta: { ...(summaryQYYs9RSp3hkD4XZZg1O_459lxDhVUz993aBwNO1wDRgsIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/summary.vue")
  },
  {
    name: "patients-id-vitales",
    path: "/patients/:id()/vitales",
    meta: { ...(vitalesW4JZ8MC_0FJtFhuFgPwUWVRUxapquMekdfgjSFHULKgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/vitales.vue")
  },
  {
    name: "patients-intake",
    path: "/patients/intake",
    meta: { ...(indexmdH_LVGTK89U7le_nfcSxjX8DbSuj1B5Bs_45rrjh7G34Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/intake/index.vue")
  },
  {
    name: "payments-invoices-new",
    path: "/payments/invoices/new",
    meta: { ...(newtHm_452dMcebgi0QqlnIU5LLIJGbR0QLFgyuTYiYqql1EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/payments/invoices/new.vue")
  },
  {
    name: "portal-lab-resultados",
    path: "/portal/lab/resultados",
    meta: { ...(resultadosjmf17Rf1zqGzJWfdkMfm_MGKNKphA5kc2nYbuRXzDKgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/resultados.vue")
  },
  {
    name: "portal-lab-sucursales",
    path: "/portal/lab/sucursales",
    meta: { ...(sucursalesn61O_457sTyZKhi86PpZvoPsNe7QLdMNE8CS4Kw3Cqtx4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/sucursales.vue")
  },
  {
    name: "reproduccion-donantes",
    path: "/reproduccion/donantes",
    meta: { ...(donantesi9izSh8hJ_fC3c7U_fki09XBMWIisSmrtrLmQKXNKe8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/reproduccion/donantes.vue")
  },
  {
    name: "settings-users-invite",
    path: "/settings/users/invite",
    meta: { ...(inviteH4yX59PYs0fd_45aOPZMNAjKHoiUR8ABfywr35q240ieMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/users/invite.vue")
  },
  {
    name: "shared-vitals-preview",
    path: "/shared/vitals-preview",
    meta: vitals_45previewK03xDZ1aKeY4LBrC80IkWEtjWirWNoaJyhfQNrkt3XgMeta || {},
    component: () => import("/home/runner/work/app/app/pages/shared/vitals-preview.vue")
  },
  {
    name: "cuentas-pacientes-id",
    path: "/cuentas-pacientes/:id()",
    meta: { ...(_91id_9316g5UWfKm_457hIwZgbMUdfsHcNyo_Qod27CUTsX9LVJwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cuentas-pacientes/[id].vue")
  },
  {
    name: "medicos-externos",
    path: "/medicos-externos",
    meta: { ...(indexXOTojGEFcgg7eercU_5Wf4RTDwMZeQOAi2pLx0ED8IIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/medicos-externos/index.vue")
  },
  {
    name: "payments-export-helpers",
    path: "/payments/export-helpers",
    component: () => import("/home/runner/work/app/app/pages/payments/export-helpers.ts")
  },
  {
    name: "portal-lab-facturacion",
    path: "/portal/lab/facturacion",
    meta: { ...(facturacionP6ycd2t0R5oMD3KVn1vef5w0waZnbxVAkhVcGw_45C7JAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/facturacion.vue")
  },
  {
    name: "registro-agencia",
    path: "/registro/agencia",
    meta: { ...(indexdORGHLO1Kj1rJt5FD0Ia1v_3Hi9OFg_45_45hE2Ze8GQ_qQMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/app/app/pages/registro/agencia/index.vue")
  },
  {
    name: "settings-catalog",
    path: "/settings/catalog",
    meta: { ...(indexjT7Q9v63BJUKcQcEu1YMHyKKrdKly_PWzp1J8b3e7V4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/catalog/index.vue")
  },
  {
    name: "settings-cfdi-attempts",
    path: "/settings/cfdi-attempts",
    meta: { ...(cfdi_45attemptsRbyqklnK_GT1Z15XMP_45htOOwliIpA4BOzD8ZGwjz1mMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/cfdi-attempts.vue")
  },
  {
    name: "triaje-appointmentId",
    path: "/triaje/:appointmentId()",
    meta: { ...(_91appointmentId_93PLVZNGeLFfiISz0GQoQS3PPHVEWlguIp1PUp6CW_5IkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/triaje/[appointmentId].vue")
  },
  {
    name: "admin-clinics-id-edit",
    path: "/admin/clinics/:id()/edit",
    meta: { ...(editp28LWzbIb70ugT_45k9tODUkfJKaI6jTAgCkoKCaZ7z48Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/clinics/[id]/edit.vue")
  },
  {
    name: "admin-commissions",
    path: "/admin/commissions",
    meta: { ...(indexOQsrWlznAgvE5Qy1g0wcXCqYOYQP8aq58K2WZrfhc78Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/commissions/index.vue")
  },
  {
    name: "admin-security-sessions",
    path: "/admin/security/sessions",
    meta: { ...(sessionsZCWoLw3roY9FXitT0D5JFQQGkcc_TfgwNhvY8QXJxVcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/security/sessions.vue")
  },
  {
    name: "cuentas-pacientes",
    path: "/cuentas-pacientes",
    meta: { ...(indexV88ZA3Nce_45fnpuKEWNxRLOdqnmDDuuFQ7ugCMqHI_4590Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/cuentas-pacientes/index.vue")
  },
  {
    name: "inventory-vacunas",
    path: "/inventory/vacunas",
    meta: { ...(index9BVSGGx9gC17Pl9TJqxD80k2a5ojLs9rLFFdDnwbBZgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/vacunas/index.vue")
  },
  {
    name: "settings-agenda-publica",
    path: "/settings/agenda-publica",
    meta: { ...(agenda_45publicacF9ti08dYr6BIlKwYrG1NT9O5AeD51f4zF67lRGD0KAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/agenda-publica.vue")
  },
  {
    name: "admin-clinics-id",
    path: "/admin/clinics/:id()",
    meta: { ...(indexj_CCBiy_45x2SPmsRIqgIc4BcFcx6asBD6taXCjhE9kdIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/clinics/[id]/index.vue")
  },
  {
    name: "admin-clinics-id-users",
    path: "/admin/clinics/:id()/users",
    meta: { ...(usersNz4H2plsbDoh5mtLAZVu7TKFGyhkLw9hTdGOzMVTKewMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/clinics/[id]/users.vue")
  },
  {
    name: "admin-lab-templates-id",
    path: "/admin/lab-templates/:id()",
    meta: { ...(_91id_93Gr0tZGCcRqAqE2EEWX5E6D8k9uN_45EScD2Muie4876UoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/lab-templates/[id].vue")
  },
  {
    name: "laboratorio-ordenes-id",
    path: "/laboratorio/ordenes/:id()",
    meta: { ...(_91id_93e_k7XBEUJldSnhwvI2DyLsw3I0TuN5loHcG12XDLwX0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/ordenes/[id].vue")
  },
  {
    name: "portal-lab-estado-cuenta",
    path: "/portal/lab/estado-cuenta",
    meta: { ...(estado_45cuentaF6Qbs23iCv_qdrCC0W_453JjdVqAIO3xr41OvqVnwHF_sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/estado-cuenta.vue")
  },
  {
    name: "settings-google-calendar",
    path: "/settings/google-calendar",
    meta: { ...(google_45calendarMqh8eHgDDm70b0FKu5KfQQkpSgroC7vCbf95TX8BDa0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/google-calendar.vue")
  },
  {
    name: "settings-locations",
    path: "/settings/locations",
    meta: { ...(indexSoLXhZ6TJoy7TbEENORh2XwSvKNBEyIMz6TAUzz1AA8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/locations/index.vue")
  },
  {
    name: "settings-vademecum-stats",
    path: "/settings/vademecum-stats",
    meta: { ...(vademecum_45statscoAWnCmN19T2zae3HGYDrYx__NR2w_45XHoARWx4RPhSIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/vademecum-stats.vue")
  },
  {
    name: "surgeries-public-token",
    path: "/surgeries/public/:token()",
    meta: { ...(_91token_93Vdv9zZYRTYNp6_45BQl_45FaZ9z5Ob0CNFEPRM4PAfQ0YNoMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/app/app/pages/surgeries/public/[token].vue")
  },
  {
    name: "vacunas-pendientes",
    path: "/vacunas/pendientes",
    meta: { ...(indexxEdFYTgZUWLIjGEt8Aw6Ebg132CpLEW_1cHUPVftzaAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/vacunas/pendientes/index.vue")
  },
  {
    name: "admin-lab-templates",
    path: "/admin/lab-templates",
    meta: { ...(indexBSbS6FSW8DLzJuUxLWdYoJTxsGd6ozF6gtXnE3AdvnsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/lab-templates/index.vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: { ...(indexDKp4uED2kZz_45a_45voTwwmabfxkrCMJBTJSadB1zCUl9YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/notifications/index.vue")
  },
  {
    name: "informes-financiero-owner",
    path: "/informes/financiero-owner",
    meta: { ...(financiero_45ownerJiGtCtz_45IVRhIaXPdxBcoe81CsqKvKYghyKbCB9ua9UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/financiero-owner.vue")
  },
  {
    name: "informes-inventario-owner",
    path: "/informes/inventario-owner",
    meta: { ...(inventario_45ownertmX8A35hJNAqhrEiRuSSq5HIrtekMwI56TEdLkJSrEIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/informes/inventario-owner.vue")
  },
  {
    name: "inventory-movements",
    path: "/inventory/movements",
    meta: { ...(indexPS11LrPanXjV7RGOXLrPPb9yYyVdqwarXwuzZ_jpjVkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/movements/index.vue")
  },
  {
    name: "inventory-products-create",
    path: "/inventory/products/create",
    meta: { ...(createH0l9onx1gReQhQLa2FQnw__8ZBbIaOtqWIBct0ZnQmIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/products/create.vue")
  },
  {
    name: "inventory-suppliers",
    path: "/inventory/suppliers",
    meta: { ...(indexF_n5aEgQnh01BMdn7m8L_45oEQTMT6juqRQ6WqGEfQEMYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/suppliers/index.vue")
  },
  {
    name: "lab-orders-public-token",
    path: "/lab-orders/public/:token()",
    meta: _91token_93gsIj74MtEE4399S_5k13ck6_45K7jDaCg8JZaXXq_45pS0cMeta || {},
    component: () => import("/home/runner/work/app/app/pages/lab-orders/public/[token].vue")
  },
  {
    name: "lab-orders-upload-token",
    path: "/lab-orders/upload/:token()",
    meta: _91token_93Fw0HzNl46lR0PuNkrjbrMzoPQdUd_iUCedghpo3UPj0Meta || {},
    component: () => import("/home/runner/work/app/app/pages/lab-orders/upload/[token].vue")
  },
  {
    name: "laboratorio-ordenes",
    path: "/laboratorio/ordenes",
    meta: { ...(index_45L0Hr5baY569wtZp8w8RFYuy_Igk9h3AFdTsNnJMJzUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/ordenes/index.vue")
  },
  {
    name: "laboratorio-senalamientos",
    path: "/laboratorio/senalamientos",
    meta: { ...(senalamientosiQLRk0vvC_plaigU6ov_6n7uqqQUkyvpcPEyjpl8yCIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/laboratorio/senalamientos.vue")
  },
  {
    name: "plan-alimentacion-token",
    path: "/plan-alimentacion/:token()",
    meta: _91token_93_HF2uXNlII9WXww7YJJ8VZQC9IH6Ke5bAH_45J2XbdgQYMeta || {},
    component: () => import("/home/runner/work/app/app/pages/plan-alimentacion/[token].vue")
  },
  {
    name: "portal-lab-reportes-cobro",
    path: "/portal/lab/reportes-cobro",
    meta: { ...(reportes_45cobrow6FIcITyAMCeqicA4jrg6RYc0xHeq1xMtfu3oOWedVIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/portal/lab/reportes-cobro.vue")
  },
  {
    name: "settings-vaccine-schedule",
    path: "/settings/vaccine-schedule",
    meta: { ...(vaccine_45scheduleFC76ETl9RQBvOAUBfqx9kJ4n0R6rrNV2ohYwQivt18oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/vaccine-schedule.vue")
  },
  {
    name: "admin-especialidades",
    path: "/admin/especialidades",
    meta: { ...(indexTHaV9QRFXDGwLvi5_4538fZYG7NR4sZiJzRdGQUcrBKM0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/especialidades/index.vue")
  },
  {
    name: "inventory-categories",
    path: "/inventory/categories",
    meta: { ...(indexTdukudrzdfyO8NHkW_LbXzTvSLrdJIk6EAOfVMPBtVEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/categories/index.vue")
  },
  {
    name: "patients-id-portal",
    path: "/patients/:id()/portal",
    meta: { ...(indexNkinaBtIjZl19OLNuNO1H3XIHJVsS7HWQG_KwR_45I2icMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/portal/index.vue")
  },
  {
    name: "registro-agencia-verificar",
    path: "/registro/agencia/verificar",
    meta: { ...(verificarPGY4MZtsMCkflkQWeIZQU5RVBwx_9trsektoWHOTvGwMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/app/app/pages/registro/agencia/verificar.vue")
  },
  {
    name: "settings-agencias-cobranza",
    path: "/settings/agencias-cobranza",
    meta: { ...(agencias_45cobranza_45dWZUkuFcEWj4sZ1vuA24d_45mrNVvzpaIAjRORTaNCyEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/agencias-cobranza.vue")
  },
  {
    name: "settings-payment-providers",
    path: "/settings/payment-providers",
    meta: { ...(payment_45providers71iEO8Sdzkg8OCeUxS6O2lf5Fbh_7nRRef7KkfqemgAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/payment-providers.vue")
  },
  {
    name: "settings-permissions",
    path: "/settings/permissions",
    meta: { ...(indexR_898RY_Iwmu3ASVovQbnUgTN5qU1bXhn62Hx3BpvFEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/permissions/index.vue")
  },
  {
    name: "settings-staff-assignments",
    path: "/settings/staff-assignments",
    meta: { ...(staff_45assignmentsZQ5_poH7CGkc89wH1ngF3_45zknnvmuLjoCf7ENwNuzRwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/staff-assignments.vue")
  },
  {
    name: "admin-cofepris-clinics-id",
    path: "/admin/cofepris/clinics/:id()",
    meta: { ...(_91id_93Kxob_DXESDYQPTaz_453ay4EoC1tcYgfJ39kPXyImoL5kMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/cofepris/clinics/[id].vue")
  },
  {
    name: "admin-especialidades-slug",
    path: "/admin/especialidades/:slug()",
    meta: { ...(_91slug_93QBM2hvz7wFwLne9OwsL_45pFsQrWSvb0z93CoO5PzHAi4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/especialidades/[slug].vue")
  },
  {
    name: "admin-security-ip-allowlist",
    path: "/admin/security/ip-allowlist",
    meta: { ...(ip_45allowlistJ8M5iXjn6Y_y0k7oO1iVJCtQFHEPIQ5l9Q9KjGEk0PIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/admin/security/ip-allowlist.vue")
  },
  {
    name: "maternal-fetal-calculadoras",
    path: "/maternal-fetal/calculadoras",
    meta: { ...(calculadorasBkXUSYFYpA_1sg2_TWectIcfRgYyRMOV9L7tvQ0SmyIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/maternal-fetal/calculadoras.vue")
  },
  {
    name: "inventory-products-id-edit",
    path: "/inventory/products/:id()/edit",
    meta: { ...(editkcEG1Dnrav86YcFffXOj4d5MOzlJz8KZKMRU8PwSJ7YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/products/[id]/edit.vue")
  },
  {
    name: "patients-id-consulta-nueva",
    path: "/patients/:id()/consulta/nueva",
    meta: { ...(nuevaGoowFT2Racm9DGZNYX5CQjV2Y7nocR3WM2CX5nrL34sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/consulta/nueva.vue")
  },
  {
    name: "patients-id-estudios",
    path: "/patients/:id()/estudios",
    meta: { ...(indexIiCCXpRuqorAm59o52U9xZ07aOrxljcdXHuUlKPAlb0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/estudios/index.vue")
  },
  {
    name: "settings-insurance-templates",
    path: "/settings/insurance-templates",
    meta: { ...(insurance_45templatesL5VQAsH1pwi0oo7IdfJI32KA9ZCX5kSUic9BIbjYvowMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/insurance-templates.vue")
  },
  {
    name: "settings-prescription-fields",
    path: "/settings/prescription-fields",
    meta: { ...(prescription_45fields9axyi0BJ1GcMTmBzD0MLbhAbcc1l3kal20naaskSSWkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/prescription-fields.vue")
  },
  {
    name: "settings-tarifas-quirurgicas",
    path: "/settings/tarifas-quirurgicas",
    meta: { ...(tarifas_45quirurgicasdQpGBhFI0zbXrve4aJO6Bi_qf8sWhwW5P_gP_EqeDSwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/tarifas-quirurgicas.vue")
  },
  {
    name: "dev-dashboard-modular-preview",
    path: "/dev/dashboard-modular-preview",
    meta: dashboard_45modular_45previewi6FZaWPHn9eJFAAbohgmJDBdax8cR_457MLzpEvtqhKn8Meta || {},
    component: () => import("/home/runner/work/app/app/pages/dev/dashboard-modular-preview.vue")
  },
  {
    name: "inventory-products-id",
    path: "/inventory/products/:id()",
    meta: { ...(indexGY9YwzwQfg_DH0ogQtmkrK6Xf1PesVyT1o7KT_kb8CAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/products/[id]/index.vue")
  },
  {
    name: "patients-id-consultas",
    path: "/patients/:id()/consultas",
    meta: { ...(indexekxQnoziPT7b4Q2lhRGAbTdE7ovwDDLfW0lCjXSbwSUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/consultas/index.vue")
  },
  {
    name: "prescriptions-plantillas-id",
    path: "/prescriptions/plantillas/:id()",
    meta: { ...(_91id_93eT7zw6wc3st_A2UFczd9hN_45D7DStgFwITWfNBIHlBsUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/prescriptions/plantillas/[id].vue")
  },
  {
    name: "settings-antecedentes-template",
    path: "/settings/antecedentes-template",
    meta: { ...(antecedentes_45templateofj_mEl3t1QjS9yfot_xFOblMiii7vYSEQSEnMV9HxMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/antecedentes-template.vue")
  },
  {
    name: "settings-payment-methods",
    path: "/settings/payment-methods",
    meta: { ...(index_45rZ5mp7qDqIVrS2K11JD_45Rs5HtX4VBRM74_oXgcEaDEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/payment-methods/index.vue")
  },
  {
    name: "settings-prescription-template",
    path: "/settings/prescription-template",
    meta: { ...(prescription_45templaterEO_1LhCpqJDRmvUozyc3vWs02TJYjuyupOvwfYf5HQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/prescription-template.vue")
  },
  {
    name: "inventory-purchase-orders",
    path: "/inventory/purchase-orders",
    meta: { ...(indexVb8fFR81oLRx8OLLGEgJ8ggjT11sWL4oJ9zZm4iJdzcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/purchase-orders/index.vue")
  },
  {
    name: "settings-recordatorios-cobranza",
    path: "/settings/recordatorios-cobranza",
    meta: { ...(recordatorios_45cobranzaqLXyW8X9ArpyGpKLXd02UFv9fmFt6bxiK3k1Aw58JqcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/recordatorios-cobranza.vue")
  },
  {
    name: "shared-patients-history-preview",
    path: "/shared/patients-history-preview",
    meta: patients_45history_45previewwzIXb17oJwMgy3Y_45Kg6ArXVhjEESst_d6utY_453fhkx4Meta || {},
    component: () => import("/home/runner/work/app/app/pages/shared/patients-history-preview.vue")
  },
  {
    name: "consentimiento-anestesia-token",
    path: "/consentimiento-anestesia/:token()",
    meta: _91token_93_453qlnSWSvS7WISg_pXO_oXeu8ZPw9AYm3ymA7wVOt84Meta || {},
    component: () => import("/home/runner/work/app/app/pages/consentimiento-anestesia/[token].vue")
  },
  {
    name: "settings-consultation-types-id",
    path: "/settings/consultation-types/:id()",
    meta: { ...(_91id_93HLydJT7GLP_1D2Jh2wfFyIpVG4Ll4MfXkZvAWtfAM3IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/consultation-types/[id].vue")
  },
  {
    name: "settings-whatsapp-plantilla-id",
    path: "/settings/whatsapp-plantilla/:id()",
    meta: { ...(_91id_93mmTjxJuBBBC6_45GkDBF4QoVur_atE8XvgJQ5w8Y7YCd0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/whatsapp-plantilla/[id].vue")
  },
  {
    name: "patients-id-embarazo-nacimiento",
    path: "/patients/:id()/embarazo/nacimiento",
    meta: { ...(nacimientoeXCYZ2DZqq2UnJ0R1LHssLgzMjtukg3EhMY3hf3640EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/embarazo/nacimiento.vue")
  },
  {
    name: "settings-consultation-types",
    path: "/settings/consultation-types",
    meta: { ...(index6_l_r1JUtjgVZR9Wo_45_45pG8ssSecmdYg5AuwPpLpyP3sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/settings/consultation-types/index.vue")
  },
  {
    name: "inventory-purchase-orders-id",
    path: "/inventory/purchase-orders/:id()",
    meta: { ...(indexoAvl9zbX5htB4K6yM4rzVNcoCHQYJdGVGMkGTBlaukoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/inventory/purchase-orders/[id]/index.vue")
  },
  {
    name: "patients-id-embarazo-usg-studyId",
    path: "/patients/:id()/embarazo/usg/:studyId()",
    meta: { ...(_91studyId_93uCVyx0SmSOyZbvyzsjSXDNBg4aflz_45zXGis7s7vdqkMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/embarazo/usg/[studyId].vue")
  },
  {
    name: "patients-id-consulta-consultationId",
    path: "/patients/:id()/consulta/:consultationId()",
    meta: { ...(_91consultationId_93xtzuMs_5K6qyE1tFKcigLKSRzFQ3Y0e5C4nTMFVq_4584Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/consulta/[consultationId].vue")
  },
  {
    name: "patients-id-embarazo-prenatal-visitId",
    path: "/patients/:id()/embarazo/prenatal/:visitId()",
    meta: { ...(_91visitId_93KZ0_zgAs975g0skfGETHQoGT9O1x7thb_C6XJCEzns4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/embarazo/prenatal/[visitId].vue")
  },
  {
    name: "patients-id-embarazo-anestesia-recordId",
    path: "/patients/:id()/embarazo/anestesia/:recordId()",
    meta: { ...(_91recordId_9358UZs4EhPEg_45RxQBvYGI9_ZdaMbspLdY2k0b_45Fin39MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/app/app/pages/patients/[id]/embarazo/anestesia/[recordId].vue")
  }
]